window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = 'js-focus-hidden';

    $element.first().attr('tabIndex', '-1').focus().addClass(focusClass).one('blur', callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $('a[href*=#]').on(
      'click',
      function (evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  },
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function () {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }
    return cookieEnabled;
  },
};

$(document).on('cart.requestComplete', function (event, cart) {
  $('#afterpay_price').html('$' + (Math.round(cart.total_price / 4) / 100).toFixed(2));
});

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function (array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function (array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function (array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function (value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  },
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {
  wrapTable: function () {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function () {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function () {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  },
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function (index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol,
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptionsWithoutHexOption();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptionsWithoutHexOption();
  }

  Variants.prototype = $.extend({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function (element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function (variant) {
        var satisfied = true;

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index];
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Find variant without the hex option, which will be unique for each variant and only ever have one value per variant.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptionsWithoutHexOption: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;
      var selectedVariantId = 0;
      var withOptionIndex = $('[data-option-name-handle]').data('index');

      variants.forEach(function (variant) {
        if (typeof selectedValues[0] !== 'undefined')
          if (selectedValues[0].value == variant.option1)
            for (var i = 0; i < window.variantQuantities.length; i++)
              if (variant.id == window.variantQuantities[i].id) {
                if (window.variantQuantities[i].qty < 30) {
                  $('#available-text').html('Less than 30 Left');
                  $('.product-counter').css('background-color', '#efbd4e');
                  $('.product-counter').show();
                }

                if (window.variantQuantities[i].qty < 10) {
                  $('#available-text').html('Less than 10 Left');
                  $('.product-counter').css('background-color', '#F05A60');
                  $('.product-counter').show();
                }

                if (window.variantQuantities[i].qty === 0) {
                  $('.product-counter').hide();
                }

                if (window.variantQuantities[i].qty > 30) {
                  $('.product-counter').hide();
                }
              }

        var satisfied = true;

        selectedValues.forEach(function (option) {
          if (satisfied && option.index == withOptionIndex) {
            satisfied = option.value === variant[option.index];
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptionsWithoutHexOption();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant,
      });

      if (!variant) {
        $('.store-inventory-available').hide();
        return;
      }

      $('[data-current-variant-id]').val(variant.id);
      $('[data-variant-id]').attr('data-variant-id', variant.id);

      if (typeof pickupEnabledIds !== 'undefined') {
        if (pickupEnabledIds.includes(variant.id))
          $('.store-inventory-available').show();
        else
          $('.store-inventory-available').hide();
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      this._updateData(variant);
      this._updateBundleDisplay(variant);

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant,
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant,
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      // var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      // window.history.replaceState({path: newurl}, '', newurl);
      let newurl = new URL(window.location.href);
      let params = new URLSearchParams(window.location.search);
      if (params.has('variant')) {
        params.set('variant', variant.id);
      } else {
        params.append('variant', variant.id);
      }
      newurl.search = params.toString();
      window.history.replaceState({path: newurl.toString()}, '', newurl.toString());
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    },

    /**
     * Update miscellaneous data attributes
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateData: function (variant) {
      $('[data-variant-switch] [data-cart-add]').attr('data-cart-add', variant.id);
      $('[data-variant-switch] [data-add-quantity]').attr('data-add-quantity', variant.id);
    },

    /**
     * Update bundle display on bundle products
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateBundleDisplay: function (variant) {
      $('[data-bundle-display]').fadeOut();
      $('[data-bundle-display="' + variant.id + '"]').fadeIn();
    },
  });

  return Variants;
})();

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function () {
  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    switchEnabled: '[data-variant-switch]',
    addToCartWrap: '[data-add-to-cart-wrap]',
    outOfStock: '[data-out-of-stock]',
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject,
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {
    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function (evt) {
      var variant = evt.variant;
      if (!variant) return;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container).html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function (evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);

      if (this.$featuredImage.hasClass('image-zoom')) {
        this.$featuredImage.parent().trigger('zoom.destroy').zoom({url: sizedImgUrl});
      }
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      this.$container.off(this.namespace);
    },
  });

  return Product;
})();

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function () {
  $('.js-address-delete').on('click', function () {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    //if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
    Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    //}
  });

  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew',
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function () {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector,
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function () {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function () {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  // $('.address-delete').on('click', function() {
  //   var $el = $(this);
  //   var formId = $el.data('form-id');
  //   var confirmMessage = $el.data('confirm-message');
  //   if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
  //     Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
  //   }
  // });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */
/*
theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '.recover_password',
    hideRecoverPasswordLink: '.hide_recover_password'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  //Show/Hide recover password form
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerSigninForm').toggleClass('hide');
  }


  //Show reset password success message
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();
*/

/**
 * Product page functionality
 *
 * Can't add data to button via jQuery. See https://stackoverflow.com/questions/37287990/jquery-data-not-updating-data-attribute
 */
$(document).ready(function () {

  var $optionLabel = $('.variant-label'),
    $productVariantTitle = $('.product-variant-title'),
    $productVariantSwatch = $('.product-variant-swatch'),
    $minusIcon = $('.minus'),
    $plusIcon = $('.plus');

  /* show the image on variant change */
  $optionLabel.on('click', function () {
    // hide award icon
    if ($('[data-product-featured-icon]').is(':visible')) {
      $('[data-product-featured-icon]').hide();
    }
    if ($('[data-product-featured-video]').parent().length > 0) {
      if ($('[data-product-featured-video]').parent().is(':visible')) {
        $('[data-product-featured-video]').parent().get(0).pause();
        $('[data-product-featured-video]').parent().hide();
        $('[data-product-featured-image]').show();
      }
    }
  });

  /* change qty of products */
  $minusIcon.on('click', function () {
    var inputTypeNumber = $(this).siblings('input[type=number]');
    if (+inputTypeNumber.val() > 1) {
      inputTypeNumber.val(+inputTypeNumber.val() - 1).trigger('change');
    }
  });

  $plusIcon.on('click', function () {
    var inputTypeNumber = $(this).siblings('input[type=number]');
    inputTypeNumber.val(+inputTypeNumber.val() + 1).trigger('change');
  });

  /* product image zoom init only on devices bigger than tablet */
  /* product image zoom init */
  // if (window.screen.width > 1024) {
  //     $('.image-zoom')
  //         .wrap('<span class="zoom" style="display:inline-block"></span>')
  //         .css('display', 'block')
  //         .parent()
  //         .zoom({
  //             url: $(this).find('img').attr('data-zoom')
  //         });
  // }

  /**
   * This is essential to trigger cart update events. Will trigger functions in product.js and variant.js
   */
  $('input[name="Size"]').on('change', function () {
    $('[data-option-name-handle="' + 'Size' + '"]')
      .val($(this).val())
      .change();
  });

  /* dynamic change product variant title and swatch */
  $optionLabel.on('click touchend', function () {
    $(this).siblings('input[type=radio]').val();
    $productVariantTitle.text($(this).siblings('input[type=radio]').val());
    $productVariantSwatch.css('background-color', $(this).css('background-color'));
  });

  $('.quick-product-form button.add-to-cart').on('click', function (e) {
    e.preventDefault();
    var form = $(this).closest('form');
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      success: function (data) {
        // Close quick shop modal on add
        $('.product-tooltip-quickshop-wrapper').hide();
        CartJS.getCart();
      },
    });
  });
});

$(document).ready(function () {
  preOrderMessageAtc();
});

function preOrderMessageAtc() {
  $('[data-add-to-cart]').on('click', function (e) {
    var messageVal = $('#preOrderMessage').val();
    const variantId = document.querySelector('[data-current-variant]')?.dataset?.currentVariant ?? '';

    if (messageVal !== '' && variantId !== '') {
      e.preventDefault();
      e.stopImmediatePropagation();
      var poMessage = $('#preOrderMessage').val();
      var form = $(this).closest('form');
      var formData =
        form.serialize() + '&quantity=1' + '&properties[_PreOrderMessage]=' + encodeURIComponent(poMessage) + '&id=' + variantId;

      const cartButton = e?.target?.querySelector('[data-add-to-cart-text]');
      if (cartButton) {
        updateAddToCartText(cartButton, translationsCartButton[translationsCountrySelector]['adding']);
      }

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function (data) {
          CartJS.getCart();
          updateAddToCartText(cartButton, translationsCartButton[translationsCountrySelector]['added']);
          console.log('ON SUBMIT SUCCESS: ' + poMessage + ' data - ', data);
        },
      });
    }
  });
}

function showExtendedShades() {
  $('[data-extended-shade]').fadeIn();
  $(event.target).fadeOut();
}

// Product image switching
$('[data-product-single-thumbnail]').on('click', function (e) {
  e.preventDefault();
  var switchImageUrl = $(this).find('img').attr('data-full-src');
  // hide award icon
  if ($('[data-product-featured-icon]').is(':visible')) {
    $('[data-product-featured-icon]').hide();
  }
  $('[data-product-featured-image]').attr('src', switchImageUrl).parent();
  $('[data-product-featured-video]').parent().get(0).pause();
  $('[data-product-featured-video]').parent().hide();
  $('[data-product-featured-image]').show();
});

// Product video click
$('[data-product-video-thumbnail]').on('click', function (e) {
  e.preventDefault();
  var switchVideoUrl = $(this).find('img').attr('data-full-src');
  // hide award icon
  if ($('[data-product-featured-icon]').is(':visible')) {
    $('[data-product-featured-icon]').hide();
  }
  $('[data-product-featured-video]').attr('src', switchVideoUrl).parent();
  $('[data-product-featured-image]').hide();
  $('[data-product-featured-video]').parent().show();
  $('[data-product-featured-video]').parent().get(0).play();
});

Shopify.queryParams = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}
// jQuery('#sort-select')
//   .bind('change', function() {
//     Shopify.queryParams.sort_by = jQuery(this).val();
//     location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
//   });

$('.truncate-lines-read-more').on('click', function () {
  $(this).parents('.truncate-lines-container').find('.truncate-lines-text').removeClass('truncate-3-lines');
  $(this).fadeOut();
});

function isOverflown(element) {
  return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}

$(document).ready(function () {
  $('.truncate-lines-text').each(function () {
    if (isOverflown(this)) {
      $(this).parents('.truncate-lines-container').find('.truncate-lines-read-more').show();
    } else {
      $(this).parents('.truncate-lines-container').find('.truncate-lines-read-more').hide();
      $(this).parents('.truncate-lines-container').find('.truncate-lines-text').removeClass('truncate-3-lines');
    }
  });
});

/*=============== Components ================*/
// Get querystring parameters
function getParameterByName(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
    results = regex.exec(location.search);
  return results == null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}
/*
  Accordion functionality
*/
$(document).ready(function () {
  var $window = $(window),
    accItemHead = $('.accordion-head'),
    collectionPage = $('.collection-page'),
    blogPage = $('.blog-page'),
    accordionItem = $('.accordion');

  accItemHead.click(function () {
    var accItemWrap = $(this).parent('.accordion');
    accItemWrap.hasClass('active') ? accItemWrap.removeClass('active') : accItemWrap.addClass('active');
  });

  // function toggleAccordion() {
  //   if (collectionPage.length || blogPage.length) {
  //     if ($window.width() > 767) {
  //      accordionItem.addClass('active');
  //    } else {
  //      accordionItem.removeClass('active');
  //     }
  //   }
  // }
  //
  // toggleAccordion();
  //
  // $window.on('resize orientationchange', function() {
  //  toggleAccordion();
  // });
});
var cartCount = 0;
var updateLabel = '';
var translationsCountrySelector = '';

translationsCountrySelector = 'en';

// Translated content
var translationsCartButton = {
  en: {
    added: 'ADDED',
    adding: 'ADDING',
    plus_qty_to_cart: 'PLUS QTY TO CART',
    added_to_cart: 'ADDED TO BAG',
    error: 'ERROR',
    add_to_bag: 'ADD TO BAG',
    removed_from_cart: 'REMOVED FROM CART',
    minus_qty_from_cart: 'MINUS QTY FROM CART',
  },
};

function updateAddToCartText(cartButton, text) {

  cartButton.innerText = text;
  const stickyAddToCartText = document.querySelector('[data-sticky-add-to-cart-text]');
  if (stickyAddToCartText) {
    stickyAddToCartText.innerText = text;
  }
}

$(document).on('cart.requestStarted', function (event, cart) {
  cartCount = cart.item_count;

  const cartButton = window.selectorButton !== undefined ? window.selectorButton.button.querySelector('[data-add-to-cart-text]') : event.target;
  if (!cartButton) return;
  updateAddToCartText(cartButton, translationsCartButton[translationsCountrySelector]['adding']);
});

$(document).on('cart.requestComplete', function (event, cart) {

  const cartButton = window.selectorButton !== undefined ? window.selectorButton.button.querySelector('[data-add-to-cart-text]') : event.target !== document ? event.target : document.querySelector('[data-add-to-cart-text]');

  if (cart.item_count > cartCount) {
    updateAddToCartText(cartButton, translationsCartButton[translationsCountrySelector]['added']);

    // Choose the correct label for the segment push
    if (updateLabel !== 'Plus Qty to Cart')
      updateLabel = translationsCartButton[translationsCountrySelector]['added_to_cart'];
  } else {
    updateAddToCartText(cartButton, translationsCartButton[translationsCountrySelector]['error']);
  }
  setTimeout(function () {
    var $targetSelected = $('.same-as-selected');

    if (cartButton && cartButton.classList.contains('btn-preorder-text')) {
      updateAddToCartText(cartButton, 'PREORDER');
    } else if ($targetSelected.attr('id') === 'is-preorder') {
      updateAddToCartText(cartButton, 'PREORDER');
    } else {
      updateAddToCartText(cartButton, translationsCartButton[translationsCountrySelector]['add_to_bag']);
    }
  }, 2000);
  cartCount = 0;

  var cartTotalPrice = cart.total_price / 100;
  var cartQty = cart.item_count;

  /** TODO: Review this code */
  var cartTaxale = cartTotalPrice;
  if (window?.theme?.region == 'AU') {
    var gst = 0;
    $(cart.items).each(function(index, item) {
      if (item.taxable == true) {
        var total = item.price * item.quantity;
        gst = gst + total;
      }
    });
    cartTaxale = gst / 100;
  }

  //Update item count
  $('[data-cart-count]').html(cartQty);
  //Update cart totals
  // $('[data-cart-total]').html('<span class="money" data-currency="' + Currency.currentCurrency + '" data-currency-' + Currency.currentCurrency + '="' + slate.Currency.formatMoney(Currency.convert(cartTotalPrice, Currency.storeNativeCurrency, Currency.currentCurrency), Currency.moneyFormats[Currency.currentCurrency].money_format) + '">' + slate.Currency.formatMoney(Currency.convert(cartTotalPrice, Currency.storeNativeCurrency, Currency.currentCurrency), Currency.moneyFormats[Currency.currentCurrency].money_format).split('"').join('') + '</span>');
  $('[data-cart-subtotal]').html('AU$' + cartTotalPrice.toFixed(2));
  $('[data-cart-total]').html('AU$' + cartTotalPrice.toFixed(2));
  /** TODO: Review this code */
  $('[data-cart-gst]').html('AU$' + (cartTaxale / 11).toFixed(2));

  // $('[data-cart-total-points]').html(Math.floor(cartTotalPrice / 100 * 2));
  //Remove removed line items
  $('[data-remove-line]').remove();

  if (cart.items.length > 0) {
    //Update line totals
    /*for (var i = 0; i < cart.items.length; i++) {
            $('[data-line-index="' + (i + 1) + '"] [data-line-total]').html('<span class="money" data-currency="' + Currency.currentCurrency + '" data-currency-' + Currency.currentCurrency + '="' + slate.Currency.formatMoney(Currency.convert(cart.items[i].line_price, Currency.storeNativeCurrency, Currency.currentCurrency), Currency.moneyFormats[Currency.currentCurrency].money_format) + '">' + slate.Currency.formatMoney(Currency.convert(cart.items[i].line_price, Currency.storeNativeCurrency, Currency.currentCurrency), Currency.moneyFormats[Currency.currentCurrency].money_format).split('"').join('') + '</span>');
        }*/

    //Update free shipping text
    // var freeShippingThreshold = $('[data-shipping-threshold]').data('shipping-threshold');
    // var freeShippingDifference = freeShippingThreshold - cartTotalPrice;
    // if (freeShippingDifference >= 0) {
    //     $('.shipping-text').html('You\'re <span class="money" data-currency="' + Currency.currentCurrency + '" data-currency-' + Currency.currentCurrency + '="' + slate.Currency.formatMoney(Currency.convert(freeShippingDifference, Currency.storeNativeCurrency, Currency.currentCurrency), Currency.moneyFormats[Currency.currentCurrency].money_format) + '">' + slate.Currency.formatMoney(Currency.convert(freeShippingDifference, Currency.storeNativeCurrency, Currency.currentCurrency), Currency.moneyFormats[Currency.currentCurrency].money_format).split('"').join('') + '</span> away from <br/><span class="semibold">free shipping!</span>');
    //
    // if ($('#afterpay_price').length == 1)
    //     $('#afterpay_price').html('$' + (Math.round(cartTotalPrice / 4) / 100).toFixed(2));
    //
    // } else {
    //     $('.shipping-text').html('You qualify for <br/><span class="semibold">free shipping!</span>');
    // }

    // var sendData = [];
    //
    var currencySymbol = 'AU$ ';
    var currencyName = '';
    if (cart.currency != 'AUD') {
      currencySymbol = '$';
      currencyName = 'USD ';
    }
    cartTotalPrice = currencyName + currencySymbol + cartTotalPrice.toFixed(2);
    if ($('.empty-crt').length) {
      $('.empty-crt').remove();
      var addHtml =
        "<ul class='header-nav-bag-list'></ul><div class='cart-sub-total'><span class='label'>Sub Total</span> <span class='amount'>cartTotalPrice</span><div class='cart-summary__duties'></div></div><a href='/cart'><button type='button' class='bag-detail-link' name='button'>View Bag Details</button></a><a href='/cart'><button type='button' class='button button--dark'>Checkout</button></a>";
      if (window?.theme?.region == 'AU') {
        /** TODO: Review this code */
        addHtml += "<span class='seprater'>OR</span><a href='/checkout' class='after-pay-btn'>Pay with <img src='https://cdn.shopify.com/s/files/1/0316/2220/1477/files/afterpay-lockup-blackonwhite_1.svg?v=1597671599' alt='afterpay image'></a>";
      }
      $('.mini-cart-inner h3').after(addHtml);
    }
    $('.header-nav-bag-list').empty();

    Object.keys(cart.items).forEach(function (key) {
      //console.log(cart.items[key]);
      //sendData.push({ title: cart.items[key].product_title, product_id: cart.items[key].product_id, price: cart.items[key].price, quantity: cart.items[key].quantity, product_type: cart.items[key].product_type });
      var proOptions = '';
      var poMessage = '';
      Object.keys(cart.items[key].options_with_values).forEach(function (key1) {
        if (cart.items[key].options_with_values[key1].name == 'Size') {
          var value = cart.items[key].options_with_values[key1].value;
          if (value != 'OS') {
            if (cart.currency != 'AUD') {
              value = 'US ' + (parseInt(value) - 4);
            } else {
              value = 'AU ' + value;
            }
          }
          value = cart.items[key].options_with_values[key1].value;
          proOptions += '<p>' + cart.items[key].options_with_values[key1].name + ': ' + value + '</p>';
        } else {
          proOptions +=
            '<p>' +
            cart.items[key].options_with_values[key1].name +
            ': ' +
            cart.items[key].options_with_values[key1].value +
            '</p>';
          if (cart.items[key].properties && cart.items[key].properties._PreOrderMessage != null) {
            poMessage += cart.items[key].properties._PreOrderMessage;
          }
        }
      });
      var proPrice =
        '<span>' + currencyName + currencySymbol + (cart.items[key].discounted_price / 100).toFixed(2) + '</span>';
      var variantId = cart.items[key].variant_id;
      const currentVariant = document.querySelector(`[data-var-id="${variantId}"]`);
      const preorderBadge = currentVariant?.dataset?.preorderBadge;
      const poBadges = preorderBadge ? preorderBadge + ' | ' : '';

      if (cart.items[key].product_type == 'giftnote_giftcard') {
        /** TODO: Review this code */
        $('.header-nav-bag-list').append(
          "<li data-product-id='" +
            cart.items[key].product_id +
            "' class='header-nav-bag-item'><span class='img-box'><a href='/pages/gift-card'><img src='" +
            cart.items[key].image +
            "'></a></span><span class='header-nav-bag-item-info'><p><a href='/pages/gift-card'><strong class='header-nav-bag-item-info-title' >" +
            cart.items[key].product_title +
            '</strong></a></p>' +
            proOptions +
            '<p>Quantity: ' +
            cart.items[key].quantity +
            "</p><p class='header-nav-bag-item-price'>Price: " +
            proPrice +
            '</p>' +
            (typeof poMessage !== 'undefined' || poMessage !== null ? "<p>" + poMessage + "</p>" : "") +
            '</span></li>'
        );
      } else {
        $('.header-nav-bag-list').append(
          "<li data-product-id='" +
            cart.items[key].product_id +
            "' class='header-nav-bag-item'><span class='img-box'><a href='" +
            cart.items[key].url +
            "'><img src='" +
            cart.items[key].image +
            "'></a></span><span class='header-nav-bag-item-info'><p><a href='" +
            cart.items[key].url +
            "'><strong class='header-nav-bag-item-info-title' >" +
            poBadges +
            cart.items[key].product_title +
            '</strong></a></p>' +
            proOptions +
            '<p>Quantity: ' +
            cart.items[key].quantity +
            "</p><p class='header-nav-bag-item-price'>Price: " +
            proPrice +
            '</p>' +
            (typeof poMessage !== 'undefined' || poMessage !== null ? '<p>' + poMessage + '</p>' : '') +
            '</span></li>'
        );
      }
      $('.cart-sub-total .amount').html(cartTotalPrice);
      if ($('body.template-cart').length == 0) $('.minicart').addClass('minicart-active');
      var minicartTimeout = 3000;
      if (window.outerWidth < 767) minicartTimeout = 2000;
      setTimeout(function () {
        $('.minicart').removeClass('minicart-active');
      }, minicartTimeout);

      $.getJSON(window.Shopify.routes.root + 'products/' + cart.items[key].handle + '.js', function (product) {
        $('.header-nav-bag-item[data-product-id="' + product.id + '"]')
          .find('.header-nav-bag-item-price')
          .find('span s')
          .remove();
        if (product.compare_at_price > product.price) {
          $('.header-nav-bag-item[data-product-id="' + product.id + '"]')
            .find('.header-nav-bag-item-price')
            .find('span')
            .prepend('<s>' + currencyName + currencySymbol + (product.compare_at_price / 100).toFixed(2) + '</s>');
        }
        Object.keys(product.tags).forEach(function (key) {
          if (product.tags[key].indexOf('pre-order') != -1) {
            var preorder_text = product.tags[key].replace(/pre-order/g, '').replace(/_/g, ' ');
            $('.header-nav-bag-item[data-product-id="' + product.id + '"]')
              .find('.header-nav-bag-item-info-title')
              .find('strong')
              .remove();
            $('.header-nav-bag-item[data-product-id="' + product.id + '"]')
              .find('.item-preorder-notice')
              .remove();
            $('.header-nav-bag-item[data-product-id="' + product.id + '"]')
              .find('.header-nav-bag-item-info-title')
              .prepend('<strong class="preorder">PREORDER | </strong>');
            $('.header-nav-bag-item[data-product-id="' + product.id + '"] .header-nav-bag-item-info').append(
              '<div class="item-preorder-notice">Pre-order this item today, it will ship ' + preorder_text + '</div>'
            );
          }
          if (product.tags[key].indexOf('final-sale') != -1) {
            $('.header-nav-bag-item[data-product-id="' + product.id + '"]')
              .find('.item-final-sale-notice')
              .remove();
            $('.header-nav-bag-item[data-product-id="' + product.id + '"] .header-nav-bag-item-info').append(
              '<div class="item-final-sale-notice">FINAL SALE</div>'
            );
          }
        });
      });
    });
  } else {
    //show empty cart text
    $('[data-cart-content]').fadeOut();
    $('[data-empty-cart-text]').fadeIn();

    window.location.reload();
  }
});

$(document).on('click', function (event) {
  if ($('.minicart.minicart-active').length) {
    console.log(event.target);
    console.log($(event.target).parents('.minicart').length);
    if ($(event.target).parents('.minicart').length) {
    } else {
      event.preventDefault();
      $('.minicart.minicart-active').removeClass('minicart-active');
    }
  }
});

$('[data-cart-remove]').on('click', function () {
  //Fade cart line out on remove and mark for removal on cart update
  var lineIndex = $(this).attr('data-cart-remove');
  $('[data-line-index="' + lineIndex + '"]')
    .fadeOut()
    .attr('data-remove-line', '');

  // Change other line indexes to reflect updated cart
  $('[data-line-index]').each(function () {
    if ($(this).attr('data-line-index') > lineIndex) {
      $(this).attr('data-line-index', $(this).attr('data-line-index') - 1);
      var lineRemove = $(this).find('[data-cart-remove]');
      var lineQtyUpdate = $(this).find('[data-cart-update]');
      $(lineRemove).attr('data-cart-remove', $(lineRemove).attr('data-cart-remove') - 1);
      $(lineQtyUpdate).attr('data-cart-update', $(lineQtyUpdate).attr('data-cart-update') - 1);
    }
  });

  // updateLabel = translationsCartButton[translationsCountrySelector]["removed_from_cart"];
});

// $('[data-add-quantity]').on('change', function () {
//     //Use quantity field for product add
//     var addQty = $(this).val();
//     $(this).parents('form').find('[data-cart-add="' + $(this).attr('data-add-quantity') + '"]').attr('data-cart-quantity', $(this).val());
//     $('[data-univ-quantity]').each(function () {
//         if ($(this).val() != addQty) {
//             $(this).val(addQty).change();
//         }
//     });
//
//     updateLabel = translationsCartButton[translationsCountrySelector]["removed_from_cart"];
// });

// $('[data-minus-qty]').on('click', function () {
//     updateLabel = translationsCartButton[translationsCountrySelector]["minus_qty_from_cart"];
// });

// $('[data-plus-qty]').on('click', function () {
//     updateLabel = translationsCartButton[translationsCountrySelector]["plus_qty_to_cart"];
// });

/*
Notes:

The .money selector applies to the currency switcher implementation, which requires it be inserted in the HTML money formats in the CMS. If no currency switcher is used, it needn't be added.

[data-add-quantity] should be a variant id and affects the corresponding product add element.

To Do: establish a framework for quantity input affecting only its local product add element.
*/

$('.currency.select-wrap select.currency-picker').on('change', function () {
  $('.currency.select-wrap select.currency-picker:not(this)').val($(this).val());
});
/*
  Collection filter functionality
*/

/*
  Custom script, which can be used in different templates
*/
$(document).ready(function () {
  // Mobile nav open
  $('#mobile-menu-trigger').click(function () {
    $('body').toggleClass('nav-open');
  });

  //smoothstate code for static pages
  if ($(window).width() <= 767) {
    mobileMultipagenav();
    // mobileAccordian();
    // var counter = 0;
    // //interval for changing images like slider
    // setInterval(function() {
    //   var c = counter % $('.step-block li').length;
    //   $('.step-block li').removeClass('active');
    //   $('.step-block li').eq(c).addClass('active');
    //   ++counter
    // }, 3000);
  }
  var $page = $('#multipage-section-multipage-customer-service'),
    options = {
      debug: true,
      prefetch: true,
      cacheLength: 4,
      blacklist: 'form',
      anchors: '.multipage-nav li a',
      onStart: {
        duration: 350, // Duration of our animation
        render: function ($container) {
          // Add your CSS animation reversing class
          $container.addClass('is-exiting');
          // Restart your animation
          smoothState.restartCSSAnimations();
        },
      },
      onReady: {
        duration: 0,
        render: function ($container, $newContent) {
          // Remove your CSS animation reversing class
          $container.removeClass('is-exiting');
          // Inject the new content
          $container.html($newContent);
          //custom function to add content in mobile as accordian
          if ($(window).width() <= 767) {
            //mobileAccordian();
            mobileMultipagenav();
          }
        },
      },
      onBefore: function ($currentTarget, $container) {
        if ($(window).width() <= 767) {
          // $("#content-multipage-customer-service").hide();
          // if($($currentTarget).hasClass("active")) {
          //   $page.toggleClass("close-accordian");
          // }
          // else {
          //   $(".mobile-accordian ul li a.active").css("color", "#a2a098");
          //   $page.removeClass("close-accordian");
          // }
        }
      },
    },
    smoothState = $page.smoothState(options).data('smoothState');

  $('.copy-code').click(function () {
    var $temp = $('<input>');
    $('body').append($temp);
    var copyText = $(this).parent().prev().find('.coupon-code').val();
    $temp.val(copyText).select();
    document.execCommand('copy');
    $temp.remove();
    $(this).next().addClass('active');
    setTimeout(function () {
      $('.copied-text').removeClass('active');
    }, 500);
  });
  if ($('.template-product').length) {
    if (window.matchMedia('(max-width: 767px)').matches) {
      photoswipe();
    }

    var slideImg = "<a href='#' class='close-zoom'>X</a><div class='zoom-image-carousel'>";
    $(".product-image-carousel .slick-slide:not(.slick-cloned) img:not('.mobile-only')").each(function (index, value) {
      if ($(this).attr('data-src') != undefined && $(this).parent().attr('data-slick-index') >= 0) {
        slideImg += "<div class='img-view'><img src='" + $(this).attr('data-src') + "' ></div>";
      }
      if (index == 1) {
        $('.product-image-carousel .last-slide-video').each(function (index, value) {
          if ($(this).find('video').length && !$(this).hasClass('slick-cloned')) {
            slideImg += "<div class='img-view'>" + $(this).html() + '</div>';
          }
        });
      }
    });
    if ($(".product-image-carousel .slick-slide:not(.slick-cloned) img:not('.mobile-only')").length == 1) {
      $('.product-image-carousel .last-slide-video').each(function (index, value) {
        if ($(this).find('video').length && !$(this).hasClass('slick-cloned')) {
          slideImg += "<div class='img-view'>" + $(this).html() + '</div>';
        }
      });
    }

    slideImg += '</div>';
    $('.zoom-container').html(slideImg);

    $('.zoom-image-carousel').slick({
      infinite: true,
      slidesToShow: 1,
      //speed: 500,
      prevArrow: '<button type="button" class="slick-prev" style="display:block">Previous</button>',
      nextArrow: '<button type="button" class="slick-next" style="display:block">Next</button>',
      autoplay: true,
      slidesToScroll: 1,
      autoplaySpeed: 4000,
    });

    $('.product-image-carousel .slick-slide.desktop-zoom').click(function () {
      var slickIndex = $(this).attr('data-slick-index');
      if ($(this).find('img').attr('data-src')) {
        $('.zoom-image-carousel').slick('slickGoTo', slickIndex);

        $('.zoom-image-carousel').on('setPosition', function (event, slick) {
          var currentSlide = $('.zoom-image-carousel').slick('slickCurrentSlide');
          $('.zoom-image-carousel')
            .find('.slick-active')
            .each(function () {
              if ($(this).find('video').length) {
                $(this)
                  .find('video source')
                  .each(function () {
                    if ($(this).attr('src').indexOf('mp4') != -1) {
                      ga('send', 'event', 'Video', 'Zoom Video View', $(this).attr('src'));
                    }
                  });
              }
            });
        });

        if (!window.matchMedia('(max-width: 767px)').matches) {
          //if( !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
          setTimeout(function () {
            $('body').addClass('zoom-open');
            $('.zoom-container').addClass('active');
          }, 50);
          $('.zoom-container .close-zoom, .zoom-container .img-view').click(function () {
            $('.product-image-carousel').slick('resize');
            $('body').removeClass('zoom-open');
            $('.zoom-container').removeClass('active');
          });
        }
      }
    });
  }

  // Update cart variant on the cart page.
  $(document).on('click', '.js-update-cart', function () {
    $(this).text('Updating');
    var number = $(this).data('number');
    var currentid = $(this).data('current-varid');
    var selectedid = $('#SingleOptionSelector-' + number).val();
    var qty = $('#updates_large_' + number).val();
    if (currentid == selectedid) {
      updateCart(qty, currentid);
    } else {
      addCart(qty, selectedid, currentid);
    }
  });

  $(document).on('change', '.cart-update-size', function () {
    var var_qty = $('.cart-update-size option:selected').data('qty');
    var $el = $('.cart__qty-input');
    $el.empty();
    for (i = 1; i <= var_qty; i++) {
      $el.append($('<option></option>').attr('value', i).text(i));
    }
  });

  // Show add to cart wishlist popup
  $(document).on('click', '.js-wk-link', function () {
    $('form.wk-add-item-form').css('display', 'none');
    // $("body").addClass("custom-overlay");
    var cls = $(this).data('link');
    $('form.' + cls).css('display', 'block');
  });
  $(document).on('click', '.js-wk-close', function () {
    // $("body").removeClass("custom-overlay");
    var cls = $(this).data('link');
    $('form.' + cls).css('display', 'none');
  });

  // Delete and edit popup on the cart page
  generate_popup('.js-cart-link');
  generate_popup('.js-cart-edit-link');
  close_popup('.js-cart-close');
  close_popup('.js-cart-edit-close');

  function generate_popup(event) {
    $(document).on('click', event, function () {
      $('.cart-popup').css('display', 'none');
      $('body').addClass('overlay');
      var cls = $(this).data('link');
      //console.log(cls);
      $('div.' + cls).css('display', 'block');
    });
  }

  function close_popup(event) {
    $(document).on('click', event, function () {
      $('body').removeClass('overlay');
      var cls = $(this).data('link');
      $('div.' + cls).css('display', 'none');
    });
  }

  // Size popup on the product page and wishlist page.
  $('#sizeGuideModalClose').on('click', function () {
    $('#sizeGuideModal').modal('toggle');
    if ($('.wk-add-item-form').length > 0) {
      $('.wk-add-item-form').each(function () {
        if ($(this).hasClass('wk-form-hide')) {
          $(this).css('display', 'block');
          $(this).removeClass('wk-form-hide');
        }
      });
    }
  });
  $('#sizeGuideModal').on('show.bs.modal', function (e) {
    if ($('.wk-add-item-form').length > 0) {
      $('.wk-add-item-form').each(function () {
        if ($(this).css('display') == 'block') {
          $(this).css('display', 'none');
          $(this).addClass('wk-form-hide');
        }
      });
    }
  });

  $(document).on('click', '.pass-first', function () {
    $(this).toggleClass('show-pass__eye-slash');
    if ($('body').hasClass('template-login')) {
      var passField = $('#CustomerPassword');
      var type = $('#CustomerPassword').prop('type');
    } else {
      var passField = $('.kca-form__input-group--password input');
      var type = $('.kca-form__input-group--password input').prop('type');
    }
    passField.attr('type', 'text');
    if (type == 'text') {
      passField.attr('type', 'password');
    }
  });

  $('#afterpayModalClose').on('click', function () {
    $('#afterpayModal').modal('toggle');
  });

  //$(".scrollBox-vertical").scrollBar({position:"y"});
  if ($('.template-login').length > 0) $('.scrollBox-vertical').ClassyScroll();

  var rte = $('.rte');

  // Scroll to top link functionality
  $('#scroll-top').click(function () {
    $('html, body').animate({scrollTop: 0}, 'slow');
    return false;
  });

  // Remove empty paragraphs from .rte content

  if (rte.length) {
    var paragraph = rte.find('p');
    for (var i = 0; i < paragraph.length; i++) {
      if (!/\S/.test(paragraph.eq(i).text()) && paragraph.eq(i).children().length < 1) {
        paragraph.eq(i).css({
          margin: '0',
          padding: '0',
        });
      }
    }
  }

  if ($('body').hasClass('template-product') || $('body').hasClass('template-cart')) {
    // You May also like
    /*
      $.get('/collections/you-may-also-like', function(json_string) {

            var data = jQuery.parseJSON(json_string);
            console.log(data);
            var items = data.products;
            var newItems = [];

            for (var i = 0; i < 8; i++) {
              var idx = Math.floor(Math.random() * items.length);
              newItems.push(items[idx]);
              items.splice(idx, 1);
            }

            var html = '';
            if(newItems){
                $.each(newItems,function(index,value){
                  var price = value.price;
                  html += '<div class="product"><!-- include \'wishlist-button-collection\' with '+value.id+' --><a href="/products/'+value.handle+'" class="product-image"><img src="'+value.image+'" alt="" /></a><a href="/products/'+value.handle+'" class="product-title"><p itemprop="name" >'+value.name+'</p></a><a href="/products/'+value.handle+'" class="product-price"><meta itemprop="url" content="/products/'+value.handle+'"><p itemprop="offers" itemscope itemtype="http://schema.org/Offer"> '+price+'</p></a></div>';
                });
                $("#mayalsoproducts").html(html);
            }
        });
        */
    var html = '';
    $('.related-product-handle').each(function (index, item) {
      var handle = $(this).data('handle');
      //console.log(handle);

      $.getJSON('/products/' + handle + '.js', function (data) {
        //var data = jQuery.parseJSON(json_string);
        //console.log(data);
        var priceHtml = '';
        if (data.compare_at_price > data.price) {
          priceHtml += '<s>' + slate.Currency.formatMoney(data.compare_at_price, theme.moneyFormat) + '</s>';
        }
        priceHtml += slate.Currency.formatMoney(data.price, theme.moneyFormat);
        html =
          '<div class="product"><a href="/products/' +
          data.handle +
          '" class="product-image"><!-- include \'wishlist-button-collection\' with ' +
          data.id +
          ' --><img src="' +
          data.images[0] +
          '" alt="" /></a><a href="/products/' +
          data.handle +
          '" class="product-title"><p itemprop="name" >' +
          data.title +
          '</p></a><a href="/products/' +
          data.handle +
          '" class="product-price"><meta itemprop="url" content="/products/' +
          data.handle +
          '"><p itemprop="offers" itemscope itemtype="http://schema.org/Offer"> ' +
          priceHtml +
          '</p></a></div>';
        $('#mayalsoproducts').append(html);
      });
    });
    //$("#mayalsoproducts").html(html);
  }

  $('.nav-slide').slick({
      infinite: true,
      autoplay: true,
      speed: 500,
      autoplaySpeed: 4000,
      arrows: false,
      slidesToShow: 1,
      draggable: false,
      dots: true,
  });

  if ($(window).width() < 700) {
    //for minicart
    $('.bag-link').attr('href', 'javascript:void(0)');
    $('.minicart').click(function () {
      $(this).toggleClass('minicart-active');
    });

    //for mini-wishlist
    $('.wk-link').attr('href', 'javascript:void(0)');
    $('.wishlist-section').click(function () {
      $(this).toggleClass('wishlist-active');
    });
  } else {
    $('.minicart').hover(
      function () {
        $(this).addClass('minicart-active');
      },
      function () {
        $(this).removeClass('minicart-active');
      }
    );

    $('.wishlist-section').hover(
      function () {
        $(this).addClass('wishlist-active');
      },
      function () {
        $(this).removeClass('wishlist-active');
      }
    );

    $('.user-icon').hover(
      function () {
        $(this).addClass('user-icon-active');
      },
      function () {
        $(this).removeClass('user-icon-active');
      }
    );
    $('#locationDropdown').hover(
      function () {
        $('.js-header-add').addClass('show');
      },
      function () {
        $('.js-header-add').removeClass('show');
      }
    );
  }

  if ($('body').hasClass('template-login')) {
    setTimeout(function () {
      $('.privacy-group a').click(function () {
        $('.privacy-popup').css('display', 'block');
        $('body').addClass('overlay');
      });
      $('.privacy-popup .popup-close, .privacy-popup .cancle').click(function () {
        $('.privacy-popup').css('display', 'none');
        $('body').removeClass('overlay');
      });
    }, 2000);
    $('.below-input.recover_password').click(function () {
      $('.account-popup.forgot-password').css('display', 'block');
      $('body').addClass('overlay');
    });
    $('.forgot-password .popup-close').click(function () {
      $('.account-popup.forgot-password').css('display', 'none');
      $('body').removeClass('overlay');
    });
    if ($('#RecoverPasswordForm .errors').length) {
      $('.account-popup.forgot-password').css('display', 'block');
      $('body').addClass('overlay');
    }

    if ($('#RecoverPasswordForm .success').length) {
      $('.account-popup.forgot-password').css('display', 'block');
      $('body').addClass('overlay');
    }

    if ($('#CustomerSigninForm .errors').length) {
      if (localStorage.getItem('loginError') != null) {
        var counter = parseInt(localStorage.getItem('loginError')) + 1;
        if (counter % 3 == 0) {
          //console.log("counter");
          $('.account-popup.forgot-password').css('display', 'block');
          $('body').addClass('overlay');
        }
        localStorage.setItem('loginError', counter);
      } else {
        localStorage.setItem('loginError', 1);
      }
    }
  }

  // save customer filled email address locally
  if ($('body').hasClass('template-login') || $('body#challenge').length) {
    $('#customer_login').submit(function () {
      localStorage.setItem('customeremail', $("input[name='customer[email]']").val());
    });

    if (localStorage.getItem('customeremail') != null) {
      $("input[name='customer[email]']").val(localStorage.getItem('customeremail'));
    }
  } else {
    localStorage.removeItem('customeremail');
  }

  if ($('body').hasClass('template-collection')) {
    /*
    $(".grandchild-list").each(function(){
      $(this).find("li").each(function(){
          if($(this).attr("data-breadcrumb")=="true"){
              var ahref = $(this).parent().first().find("a").attr("href");
              var avalue = $(this).parent().first().find("a").html();
              var htm = "<li class='breadcrumb-item' property='itemListElement' typeof='ListItem'><a property='item' typeof='WebPage' href='"+ahref+"'><span property='name'>"+avalue+"</span></a></li>";
              jQuery(".breadcrumbs-list li:eq(0)").after(htm);
          }
      });
    });
    */
    $('.breadcrumbs-list').css('display', 'block');
  }

  if ($('.template-index').length) {
    if ($('#insta-feed').length) {
      $('#insta-feed').wrap("<div class='instafeed-outer'></div>");
    }
    var instaInterval = setInterval(function () {
      if ($('.lightbox-instagram').length) {
        $('.lightbox-instagram').prepend('<a class="instagram-popup-cross" href="#_" style="width:12px;><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg></a>');
        $('.lightbox-instagram .description').append(
          "<img class='insta-logo' src='https://cdn.shopify.com/s/files/1/0316/2220/1477/files/logo_ll_black.png?v=1593689534' >"
        );
        $('.lightbox-instagram').wrapInner("<div class='lightbox-inner'></div>");
        clearInterval(instaInterval);
      }
    }, 500);
    setTimeout(function () {
      clearInterval(instaInterval);
    }, 20000);

    var feed = new Instafeed({
      get: 'user',
      userId: '17841404253295398',
      accessToken:
        'IGQVJYMnlfNFVTdU1kQnh4NFJJdXcyWkFpeFJqTGxLYWRvc2ZAUbDhoTE5yOUZAPRjdRRk85NTBtV0dFZA2FNNVFjR28tUVUtcWUzSk5wTGl0V1otaVYtcGtZAM0puRjdDdDk4dlQ1LXpDRU41ZA1pPbTFBVmJ5d3V4WThpMkFN',
      sortBy: 'most-recent',
      limit: 5,
      resolution: 'standard_resolution',
      template: '<div class="item"><a href="{{link}}" target="_blank"><img src="{{image}}" /></a></div>',
    });
    feed.run();

    var interval;
    interval = setInterval(function () {
      $('.instagram-popup-cross').click(function () {
        $('.instagram-popup-overlay').css('display', 'none');
      });
      $('#instafeed .item').click(function () {
        var ahref = $(this).find('a').attr('href');
        var imgsrc = $(this).find('img').attr('src');
        $('.instagram-popup-details .instagram-img').attr('src', imgsrc);
        $('.instagram-popup-details .open-instagram').attr('href', ahref);
        $('.instagram-popup-overlay').css('display', 'block');
        return false;
      });
    }, 500);
    setTimeout(function () {
      clearInterval(interval);
    }, 10000);
  }

  $('.site-nav').hover(
    function () {
      $('body').addClass('nav-opened');
    },
    function () {
      $('body').removeClass('nav-opened');
    }
  );
  $('.site-nav li').hover(
    function () {
      $(this).find('.nav-submenu-wrapper').addClass('nav-opened-1');
    },
    function () {
      $(this).find('.nav-submenu-wrapper').removeClass('nav-opened-1');
    }
  );

  $('.update-email').click(function () {
    $('.kca-form--profile .kca-form__title').text('Change Your Email');
    $('.kca-form--password').addClass('hide');
    $('.kca-form--profile').removeClass('hide');
    $('.account-popup.email-password').css('display', 'block');
    $('body').addClass('overlay');
  });
  $('.update-pass').click(function () {
    $('.kca-form--password').removeClass('hide');
    $('.kca-form--profile').addClass('hide');
    $('.account-popup.email-password').css('display', 'block');
    $('body').addClass('overlay');
  });
  $('.email-password .popup-close').click(function () {
    $('.account-popup').css('display', 'none');
    $('body').removeClass('overlay');
  });
  // Delete address event handler
  // $('.js-address-delete').on('click', function() {
  //   var $el = $(this);
  //   var formId = $el.data('form-id');
  //   var confirmMessage = $el.data('confirm-message');
  //   if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
  //     Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
  //   }
  // });
});

function updateCart(qty, var_id) {
  jQuery
    .post(
      '/cart/change.js',
      {
        quantity: qty,
        id: var_id,
      },
      null,
      'json'
    )
    .done(function (d) {
      location.reload();
    })
    .fail(function ($xhr) {
      var data = $xhr.responseJSON;
    });
}

function addCart(qty, var_id, currentid) {
  var status = 0;
  jQuery
    .post(
      '/cart/add.js',
      {
        quantity: qty,
        id: var_id,
      },
      null,
      'json'
    )
    .done(function (d) {
      $('.cart-success-msg').addClass('cart-success');
    })
    .fail(function ($xhr) {
      var data = $xhr.responseJSON;
      $('.cart-success-msg').text(data['description']);
    });

  var myVar = setInterval(myTimer, 1000);
  function myTimer() {
    if ($('.cart-success-msg.cart-success').length > 0) {
      jQuery.post('/cart/update.js', 'updates[' + currentid + ']=0');
      setTimeout(function () {
        location.href = '/cart';
      }, 1000);
      clearInterval(myVar);
    }
  }
}

//custom script to add content in mobile as accordian
function mobileAccordian() {
  if ($('.template-page').length) {
    var swapData = $('#content-multipage-customer-service').detach();
    if ($('.mobile-accordian ul li a').hasClass('active')) {
      var swapTo = $('.mobile-accordian ul li a.active').parent();
      $(swapTo).append(swapData);
    }
  }
}

function mobileMultipagenav() {
  if ($('.template-page').length) {
    $('.mobile-multipage-select-nav').change(function () {
      $("ul.multipage-nav li a[href='" + $(this).val() + "']").trigger('click');
    });
  }
}

// custom script for photoswipe
function photoswipe() {
  var pswpElement = document.querySelectorAll('.pswp')[0];
  //var items = this.getImagedata();
  var items = getImagedata();

  var options = {
    index: 0,
    closeOnScroll: false,
    tapToToggleControls: false,
  };

  var x = document.querySelectorAll('.opengallery');
  for (let i = 0; i < x.length; i++) {
    x[i].addEventListener('click', function () {
      opengallery(x[i].getAttribute('data-slick-index'));
    });
  }

  function opengallery(j) {
    options.index = parseInt(j);
    gallery1 = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
    gallery1.init();
    var imageWidth = items[0].w;
    var imageHeight = items[0].h;
    var screenWidth = $(window).width();
    var screenHeight = $(window).height();
    var zoomRatio = screenWidth / imageWidth;
    var panY = screenHeight > items[0].h * zoomRatio ? (screenHeight - items[0].h * zoomRatio) / 2 : 0;
    var panX = 0;
    if (panY > 0) {
      zoomRatio = screenHeight / imageHeight;
      panX = items[0].w * zoomRatio > screenWidth ? -(items[0].w * zoomRatio - screenWidth) / 2 : 0;
      panY = 0;
    }
    gallery1.applyZoomPan(zoomRatio, panX, panY);

    gallery1.listen('beforeChange', function () {
      if (gallery1.currItem.html != undefined) {
        gallery1.applyZoomPan(1, 0, 0);
      } else {
        var imageWidth = gallery1.currItem.w;
        var imageHeight = gallery1.currItem.h;
        var screenWidth = $(window).width();
        var screenHeight = $(window).height();
        var zoomRatio = screenWidth / imageWidth;
        var panY =
          screenHeight > gallery1.currItem.h * zoomRatio ? (screenHeight - gallery1.currItem.h * zoomRatio) / 2 : 0;
        var panX = 0;
        if (panY > 0) {
          zoomRatio = screenHeight / imageHeight;
          panX =
            gallery1.currItem.w * zoomRatio > screenWidth ? -(gallery1.currItem.w * zoomRatio - screenWidth) / 2 : 0;
          panY = 0;
        }
        gallery1.applyZoomPan(zoomRatio, panX, panY);
      }
    });

    gallery1.listen('afterChange', function () {
      if (gallery1.currItem.html != undefined) {
        gallery1.applyZoomPan(1, 0, 0);
      } else {
        var imageWidth = gallery1.currItem.w;
        var imageHeight = gallery1.currItem.h;
        var screenWidth = $(window).width();
        var screenHeight = $(window).height();
        var zoomRatio = screenWidth / imageWidth;
        var panY =
          screenHeight > gallery1.currItem.h * zoomRatio ? (screenHeight - gallery1.currItem.h * zoomRatio) / 2 : 0;
        var panX = 0;
        if (panY > 0) {
          zoomRatio = screenHeight / imageHeight;
          panX =
            gallery1.currItem.w * zoomRatio > screenWidth ? -(gallery1.currItem.w * zoomRatio - screenWidth) / 2 : 0;
          panY = 0;
        }
        gallery1.applyZoomPan(zoomRatio, panX, panY);
      }
    });

    gallery1.listen('imageLoadComplete', function (index, item) {
      if (gallery1.currItem.html != undefined) {
        gallery1.applyZoomPan(1, 0, 0);
      } else {
        var imageWidth = gallery1.currItem.w;
        var imageHeight = gallery1.currItem.h;
        var screenWidth = $(window).width();
        var screenHeight = $(window).height();
        var zoomRatio = screenWidth / imageWidth;
        var panY =
          screenHeight > gallery1.currItem.h * zoomRatio ? (screenHeight - gallery1.currItem.h * zoomRatio) / 2 : 0;
        var panX = 0;
        if (panY > 0) {
          zoomRatio = screenHeight / imageHeight;
          panX =
            gallery1.currItem.w * zoomRatio > screenWidth ? -(gallery1.currItem.w * zoomRatio - screenWidth) / 2 : 0;
          panY = 0;
        }
        gallery1.applyZoomPan(zoomRatio, panX, panY);
      }
    });

    gallery1.listen('resize', function () {
      if (gallery1.currItem.html != undefined) {
        gallery1.applyZoomPan(1, 0, 0);
      } else {
        var imageWidth = gallery1.currItem.w;
        var imageHeight = gallery1.currItem.h;
        var screenWidth = $(window).width();
        var screenHeight = $(window).height();
        var zoomRatio = screenWidth / imageWidth;
        var panY =
          screenHeight > gallery1.currItem.h * zoomRatio ? (screenHeight - gallery1.currItem.h * zoomRatio) / 2 : 0;
        var panX = 0;
        if (panY > 0) {
          zoomRatio = screenHeight / imageHeight;
          panX =
            gallery1.currItem.w * zoomRatio > screenWidth ? -(gallery1.currItem.w * zoomRatio - screenWidth) / 2 : 0;
          panY = 0;
        }
        gallery1.applyZoomPan(zoomRatio, panX, panY);
      }
    });

    gallery1.listen('parseVerticalMargin', function (item) {
      if (gallery1.currItem.html != undefined) {
        gallery1.applyZoomPan(1, 0, 0);
      } else {
        var imageWidth = gallery1.currItem.w;
        var imageHeight = gallery1.currItem.h;
        var screenWidth = $(window).width();
        var screenHeight = $(window).height();
        var zoomRatio = screenWidth / imageWidth;
        var panY =
          screenHeight > gallery1.currItem.h * zoomRatio ? (screenHeight - gallery1.currItem.h * zoomRatio) / 2 : 0;
        var panX = 0;
        if (panY > 0) {
          zoomRatio = screenHeight / imageHeight;
          panX =
            gallery1.currItem.w * zoomRatio > screenWidth ? -(gallery1.currItem.w * zoomRatio - screenWidth) / 2 : 0;
          panY = 0;
        }
        gallery1.applyZoomPan(zoomRatio, panX, panY);
      }
    });

    gallery1.listen('mouseUsed', function () {
      if (gallery1.currItem.html != undefined) {
        gallery1.applyZoomPan(1, 0, 0);
      } else {
        var imageWidth = gallery1.currItem.w;
        var imageHeight = gallery1.currItem.h;
        var screenWidth = $(window).width();
        var screenHeight = $(window).height();
        var zoomRatio = screenWidth / imageWidth;
        var panY =
          screenHeight > gallery1.currItem.h * zoomRatio ? (screenHeight - gallery1.currItem.h * zoomRatio) / 2 : 0;
        var panX = 0;
        if (panY > 0) {
          zoomRatio = screenHeight / imageHeight;
          panX =
            gallery1.currItem.w * zoomRatio > screenWidth ? -(gallery1.currItem.w * zoomRatio - screenWidth) / 2 : 0;
          panY = 0;
        }
        gallery1.applyZoomPan(zoomRatio, panX, panY);
      }
    });

    gallery1.listen('initialZoomIn', function () {
      gallery1.applyZoomPan(zoomRatio, panX, panY);
    });

    gallery1.listen('initialZoomInEnd', function () {
      gallery1.applyZoomPan(zoomRatio, panX, panY);
    });

    gallery1.listen('initialZoomOut', function () {
      gallery1.applyZoomPan(zoomRatio, panX, panY);
    });

    gallery1.listen('initialZoomOutEnd', function () {
      gallery1.applyZoomPan(zoomRatio, panX, panY);
    });
  }
}

function getImagedata() {
  //this.$images = $(".photoswipe__image");
  var haveImages = false;
  var items = [];
  var options = {};

  $('.photoswipe__image').each(function (index, value) {
    if ($(this).parent().hasClass('slick-cloned')) {
      return 1;
    }
    var haveImages = true;
    var item = {
      src: $(this).data('photoswipe-src'),
      w: $(this).data('photoswipe-width'),
      h: $(this).data('photoswipe-height'),
      msrc: $(this).data('photoswipe-msrc'),
    };

    items.push(item);

    if (index == 2) {
      $('.last-slide-video').each(function (index, value) {
        if ($(this).hasClass('slick-cloned')) {
          return 1;
        }
        var video = {
          html: $(this).html(),
        };
        items.push(video);
      });
    }
  });

  if ($('.photoswipe__image').length < 2) {
    $('.last-slide-video').each(function (index, value) {
      if ($(this).hasClass('slick-cloned')) {
        return 1;
      }
      var video = {
        html: $(this).html(),
      };
      items.push(video);
    });
  }

  return items;
}

function openAllPanels() {
  if ($('body').hasClass('template-page')) {
    // console.log("openAllPanels");
    $('.custom-tab-content .openAllPanels').hide();
    $('.custom-tab-content .closeAllPanels').show();
    $('.custom-tab-content a.card-link').removeClass('collapsed');
    $('.custom-tab-content a.card-link').attr('aria-expanded', 'true');
    $('.custom-tab-content div.collapse').addClass('show');
  }
}
function closeAllPanels() {
  if ($('body').hasClass('template-page')) {
    // console.log("closeAllPanels");
    $('.custom-tab-content .closeAllPanels').hide();
    $('.custom-tab-content .openAllPanels').show();
    $('.custom-tab-content a.card-link').addClass('collapsed');
    $('.custom-tab-content a.card-link').attr('aria-expanded', 'false');
    $('.custom-tab-content div.collapse').removeClass('show');
  }
}

/*
  Search form functionality
*/
$(document).ready(function () {
  var searchBtn = $('.top .search-btn');
  var searchLabel = $('.top .search-label');
  var searchField = $('.top .search-field');
  var closeIcon = $('.top .close-x');
  var mobileCloseIcon = $('.top .close-x-mobile');
  var searchFormWrapper = $('.top.search-wrapper');
  var widthCut = 767;

  function openSearchForm(formWrapper, className) {
    if ($(window).width() > widthCut) formWrapper.addClass(className);
  }

  function closeSearchForm(formWrapper, className) {
    if ($(window).width() > widthCut) formWrapper.removeClass(className);
  }

  searchLabel.on('click', function () {
    openSearchForm(searchFormWrapper, 'expanded');
  });

  searchBtn.on('click', function (event) {
    if (searchField.val() === '' || (!searchFormWrapper.hasClass('expanded') && $(window).width() > widthCut)) {
      event.preventDefault(event);
      openSearchForm(searchFormWrapper, 'expanded');
    }

    if (searchField.val() === '' && $(window).width() <= widthCut) {
      event.preventDefault(event);
      searchField.focus();
    }
  });

  closeIcon.on('click', function () {
    closeSearchForm(searchFormWrapper, 'expanded');
  });

  mobileCloseIcon.on('click', function () {
    searchField.val('');
  });

  if ($('.search-page').length) {
    $('.search-page-form .search-btn').on('click', function (event) {
      var value = $(this).siblings('#Search').val();
      if (!/\S/.test(value)) {
        event.preventDefault();
      }
    });
  }
});

/*// =require components/sticky-navigation.js*/

/*=============== First Party ================*/
/**
 * Subscribe button from account
 * On the blog page, exclusive offers subscribe box snippetpages
 * @param {event} event
 */
function subscribeFromAccount(email, buttonElem, messageElem) {
  buttonElem.disabled = true;
  buttonElem.innerHTML = '<i class="fas fa-spinner-third fa-spin"></i>';

  var data = {
    email: email,
  };

  var request = new XMLHttpRequest();
  request.onreadystatechange = function () {
    if (request.readyState === 4 && request.status === 200) {
      buttonElem.innerHTML = 'SUBSCRIBE';
      buttonElem.disabled = false;
      messageElem.innerText = 'You are subscribed';
      messageElem.classList.remove('hide');
      return setTimeout(function () {
        messageElem.classList.add('hide');
        messageElem.innerText = '';
      }, 2000);
    } else if (request.status === 500 || request.status === 404 || request.status === 400) {
      var message = 'There was an error please try against later';
      if (window.theme && window.theme.customerServiceEmail) {
        message += ' or email us at ' + window.theme.customerServiceEmail;
      }
      alert(message);
    }
  };

  request.open('POST', 'https://middleware-i.herokuapp.com/leoandlin/v1/subscribe', true);
  request.setRequestHeader('Content-Type', 'application/json');
  //request.setRequestHeader('Access-Control-Allow-Origin', '*');
  request.send(JSON.stringify(data));
}
// =require first-party/email.js

/*=============== Custom Code ================*/
/*
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

jQuery.cookie = function (b, j, m) {
  if (typeof j != 'undefined') {
    m = m || {};
    if (j === null) {
      j = '';
      m.expires = -1;
    }
    var e = '';
    if (m.expires && (typeof m.expires == 'number' || m.expires.toUTCString)) {
      var f;
      if (typeof m.expires == 'number') {
        f = new Date();
        f.setTime(f.getTime() + m.expires * 24 * 60 * 60 * 1000);
      } else {
        f = m.expires;
      }
      e = '; expires=' + f.toUTCString();
    }
    var l = m.path ? '; path=' + m.path : '';
    var g = m.domain ? '; domain=' + m.domain : '';
    var a = m.secure ? '; secure' : '';
    document.cookie = [b, '=', encodeURIComponent(j), e, l, g, a].join('');
  } else {
    var d = null;
    if (document.cookie && document.cookie != '') {
      var k = document.cookie.split(';');
      for (var h = 0; h < k.length; h++) {
        var c = jQuery.trim(k[h]);
        if (c.substring(0, b.length + 1) == b + '=') {
          d = decodeURIComponent(c.substring(b.length + 1));
          break;
        }
      }
    }
    return d;
  }
};

/*
 * Currency tools
 *
 * Copyright (c) 2015 Caroline Schnapp (mllegeorgesand@gmail.com)
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 */

if (typeof Currency === 'undefined') {
  var Currency = {};
}

Currency.cookie = {
  configuration: {
    expires: 365,
    path: '/',
    domain: window.location.hostname,
  },
  name: 'currency',
  write: function (currency) {
    jQuery.cookie(this.name, currency, this.configuration);
  },
  read: function () {
    return jQuery.cookie(this.name);
  },
  destroy: function () {
    jQuery.cookie(this.name, null, this.configuration);
  },
};

Currency.moneyFormats = {
  USD: {
    money_format: '${{amount}}',
    money_with_currency_format: '${{amount}} USD',
  },
  EUR: {
    money_format: '&euro;{{amount}}',
    money_with_currency_format: '&euro;{{amount}} EUR',
  },
  GBP: {
    money_format: '&pound;{{amount}}',
    money_with_currency_format: '&pound;{{amount}} GBP',
  },
  CAD: {
    money_format: '${{amount}}',
    money_with_currency_format: '${{amount}} CAD',
  },
  ALL: {
    money_format: 'Lek {{amount}}',
    money_with_currency_format: 'Lek {{amount}} ALL',
  },
  DZD: {
    money_format: 'DA {{amount}}',
    money_with_currency_format: 'DA {{amount}} DZD',
  },
  AOA: {
    money_format: 'Kz{{amount}}',
    money_with_currency_format: 'Kz{{amount}} AOA',
  },
  ARS: {
    money_format: '${{amount_with_comma_separator}}',
    money_with_currency_format: '${{amount_with_comma_separator}} ARS',
  },
  AMD: {
    money_format: '{{amount}} AMD',
    money_with_currency_format: '{{amount}} AMD',
  },
  AWG: {
    money_format: 'Afl{{amount}}',
    money_with_currency_format: 'Afl{{amount}} AWG',
  },
  AUD: {
    money_format: '${{amount}}',
    money_with_currency_format: '${{amount}} AUD',
  },
  BBD: {
    money_format: '${{amount}}',
    money_with_currency_format: '${{amount}} Bds',
  },
  AZN: {
    money_format: 'm.{{amount}}',
    money_with_currency_format: 'm.{{amount}} AZN',
  },
  BDT: {
    money_format: 'Tk {{amount}}',
    money_with_currency_format: 'Tk {{amount}} BDT',
  },
  BSD: {
    money_format: 'BS${{amount}}',
    money_with_currency_format: 'BS${{amount}} BSD',
  },
  BHD: {
    money_format: '{{amount}}0 BD',
    money_with_currency_format: '{{amount}}0 BHD',
  },
  BYR: {
    money_format: 'Br {{amount}}',
    money_with_currency_format: 'Br {{amount}} BYR',
  },
  BZD: {
    money_format: 'BZ${{amount}}',
    money_with_currency_format: 'BZ${{amount}} BZD',
  },
  BTN: {
    money_format: 'Nu {{amount}}',
    money_with_currency_format: 'Nu {{amount}} BTN',
  },
  BAM: {
    money_format: 'KM {{amount_with_comma_separator}}',
    money_with_currency_format: 'KM {{amount_with_comma_separator}} BAM',
  },
  BRL: {
    money_format: 'R$ {{amount_with_comma_separator}}',
    money_with_currency_format: 'R$ {{amount_with_comma_separator}} BRL',
  },
  BOB: {
    money_format: 'Bs{{amount_with_comma_separator}}',
    money_with_currency_format: 'Bs{{amount_with_comma_separator}} BOB',
  },
  BWP: {
    money_format: 'P{{amount}}',
    money_with_currency_format: 'P{{amount}} BWP',
  },
  BND: {
    money_format: '${{amount}}',
    money_with_currency_format: '${{amount}} BND',
  },
  BGN: {
    money_format: '{{amount}} лв',
    money_with_currency_format: '{{amount}} лв BGN',
  },
  MMK: {
    money_format: 'K{{amount}}',
    money_with_currency_format: 'K{{amount}} MMK',
  },
  KHR: {
    money_format: 'KHR{{amount}}',
    money_with_currency_format: 'KHR{{amount}}',
  },
  KYD: {
    money_format: '${{amount}}',
    money_with_currency_format: '${{amount}} KYD',
  },
  XAF: {
    money_format: 'FCFA{{amount}}',
    money_with_currency_format: 'FCFA{{amount}} XAF',
  },
  CLP: {
    money_format: '${{amount_no_decimals}}',
    money_with_currency_format: '${{amount_no_decimals}} CLP',
  },
  CNY: {
    money_format: '&#165;{{amount}}',
    money_with_currency_format: '&#165;{{amount}} CNY',
  },
  COP: {
    money_format: '${{amount_with_comma_separator}}',
    money_with_currency_format: '${{amount_with_comma_separator}} COP',
  },
  CRC: {
    money_format: '&#8353; {{amount_with_comma_separator}}',
    money_with_currency_format: '&#8353; {{amount_with_comma_separator}} CRC',
  },
  HRK: {
    money_format: '{{amount_with_comma_separator}} kn',
    money_with_currency_format: '{{amount_with_comma_separator}} kn HRK',
  },
  CZK: {
    money_format: '{{amount_with_comma_separator}} K&#269;',
    money_with_currency_format: '{{amount_with_comma_separator}} K&#269;',
  },
  DKK: {
    money_format: '{{amount_with_comma_separator}}',
    money_with_currency_format: 'kr.{{amount_with_comma_separator}}',
  },
  DOP: {
    money_format: 'RD$ {{amount}}',
    money_with_currency_format: 'RD$ {{amount}}',
  },
  XCD: {
    money_format: '${{amount}}',
    money_with_currency_format: 'EC${{amount}}',
  },
  EGP: {
    money_format: 'LE {{amount}}',
    money_with_currency_format: 'LE {{amount}} EGP',
  },
  ETB: {
    money_format: 'Br{{amount}}',
    money_with_currency_format: 'Br{{amount}} ETB',
  },
  XPF: {
    money_format: '{{amount_no_decimals_with_comma_separator}} XPF',
    money_with_currency_format: '{{amount_no_decimals_with_comma_separator}} XPF',
  },
  FJD: {
    money_format: '${{amount}}',
    money_with_currency_format: 'FJ${{amount}}',
  },
  GMD: {
    money_format: 'D {{amount}}',
    money_with_currency_format: 'D {{amount}} GMD',
  },
  GHS: {
    money_format: 'GH&#8373;{{amount}}',
    money_with_currency_format: 'GH&#8373;{{amount}}',
  },
  GTQ: {
    money_format: 'Q{{amount}}',
    money_with_currency_format: '{{amount}} GTQ',
  },
  GYD: {
    money_format: 'G${{amount}}',
    money_with_currency_format: '${{amount}} GYD',
  },
  GEL: {
    money_format: '{{amount}} GEL',
    money_with_currency_format: '{{amount}} GEL',
  },
  HNL: {
    money_format: 'L {{amount}}',
    money_with_currency_format: 'L {{amount}} HNL',
  },
  HKD: {
    money_format: '${{amount}}',
    money_with_currency_format: 'HK${{amount}}',
  },
  HUF: {
    money_format: '{{amount_no_decimals_with_comma_separator}}',
    money_with_currency_format: '{{amount_no_decimals_with_comma_separator}} Ft',
  },
  ISK: {
    money_format: '{{amount_no_decimals}} kr',
    money_with_currency_format: '{{amount_no_decimals}} kr ISK',
  },
  INR: {
    money_format: 'Rs. {{amount}}',
    money_with_currency_format: 'Rs. {{amount}}',
  },
  IDR: {
    money_format: '{{amount_with_comma_separator}}',
    money_with_currency_format: 'Rp {{amount_with_comma_separator}}',
  },
  ILS: {
    money_format: '{{amount}} NIS',
    money_with_currency_format: '{{amount}} NIS',
  },
  JMD: {
    money_format: '${{amount}}',
    money_with_currency_format: '${{amount}} JMD',
  },
  JPY: {
    money_format: '&#165;{{amount_no_decimals}}',
    money_with_currency_format: '&#165;{{amount_no_decimals}} JPY',
  },
  JEP: {
    money_format: '&pound;{{amount}}',
    money_with_currency_format: '&pound;{{amount}} JEP',
  },
  JOD: {
    money_format: '{{amount}}0 JD',
    money_with_currency_format: '{{amount}}0 JOD',
  },
  KZT: {
    money_format: '{{amount}} KZT',
    money_with_currency_format: '{{amount}} KZT',
  },
  KES: {
    money_format: 'KSh{{amount}}',
    money_with_currency_format: 'KSh{{amount}}',
  },
  KWD: {
    money_format: '{{amount}}0 KD',
    money_with_currency_format: '{{amount}}0 KWD',
  },
  KGS: {
    money_format: 'лв{{amount}}',
    money_with_currency_format: 'лв{{amount}}',
  },
  LVL: {
    money_format: 'Ls {{amount}}',
    money_with_currency_format: 'Ls {{amount}} LVL',
  },
  LBP: {
    money_format: 'L&pound;{{amount}}',
    money_with_currency_format: 'L&pound;{{amount}} LBP',
  },
  LTL: {
    money_format: '{{amount}} Lt',
    money_with_currency_format: '{{amount}} Lt',
  },
  MGA: {
    money_format: 'Ar {{amount}}',
    money_with_currency_format: 'Ar {{amount}} MGA',
  },
  MKD: {
    money_format: 'ден {{amount}}',
    money_with_currency_format: 'ден {{amount}} MKD',
  },
  MOP: {
    money_format: 'MOP${{amount}}',
    money_with_currency_format: 'MOP${{amount}}',
  },
  MVR: {
    money_format: 'Rf{{amount}}',
    money_with_currency_format: 'Rf{{amount}} MRf',
  },
  MXN: {
    money_format: '$ {{amount}}',
    money_with_currency_format: '$ {{amount}} MXN',
  },
  MYR: {
    money_format: 'RM{{amount}} MYR',
    money_with_currency_format: 'RM{{amount}} MYR',
  },
  MUR: {
    money_format: 'Rs {{amount}}',
    money_with_currency_format: 'Rs {{amount}} MUR',
  },
  MDL: {
    money_format: '{{amount}} MDL',
    money_with_currency_format: '{{amount}} MDL',
  },
  MAD: {
    money_format: '{{amount}} dh',
    money_with_currency_format: 'Dh {{amount}} MAD',
  },
  MNT: {
    money_format: '{{amount_no_decimals}} &#8366',
    money_with_currency_format: '{{amount_no_decimals}} MNT',
  },
  MZN: {
    money_format: '{{amount}} Mt',
    money_with_currency_format: 'Mt {{amount}} MZN',
  },
  NAD: {
    money_format: 'N${{amount}}',
    money_with_currency_format: 'N${{amount}} NAD',
  },
  NPR: {
    money_format: 'Rs{{amount}}',
    money_with_currency_format: 'Rs{{amount}} NPR',
  },
  ANG: {
    money_format: '&fnof;{{amount}}',
    money_with_currency_format: '{{amount}} NA&fnof;',
  },
  NZD: {
    money_format: '${{amount}}',
    money_with_currency_format: '${{amount}} NZD',
  },
  NIO: {
    money_format: 'C${{amount}}',
    money_with_currency_format: 'C${{amount}} NIO',
  },
  NGN: {
    money_format: '&#8358;{{amount}}',
    money_with_currency_format: '&#8358;{{amount}} NGN',
  },
  NOK: {
    money_format: 'kr {{amount_with_comma_separator}}',
    money_with_currency_format: 'kr {{amount_with_comma_separator}} NOK',
  },
  OMR: {
    money_format: '{{amount_with_comma_separator}} OMR',
    money_with_currency_format: '{{amount_with_comma_separator}} OMR',
  },
  PKR: {
    money_format: 'Rs.{{amount}}',
    money_with_currency_format: 'Rs.{{amount}} PKR',
  },
  PGK: {
    money_format: 'K {{amount}}',
    money_with_currency_format: 'K {{amount}} PGK',
  },
  PYG: {
    money_format: 'Gs. {{amount_no_decimals_with_comma_separator}}',
    money_with_currency_format: 'Gs. {{amount_no_decimals_with_comma_separator}} PYG',
  },
  PEN: {
    money_format: 'S/. {{amount}}',
    money_with_currency_format: 'S/. {{amount}} PEN',
  },
  PHP: {
    money_format: '&#8369;{{amount}}',
    money_with_currency_format: '&#8369;{{amount}} PHP',
  },
  PLN: {
    money_format: '{{amount_with_comma_separator}} zl',
    money_with_currency_format: '{{amount_with_comma_separator}} zl PLN',
  },
  QAR: {
    money_format: 'QAR {{amount_with_comma_separator}}',
    money_with_currency_format: 'QAR {{amount_with_comma_separator}}',
  },
  RON: {
    money_format: '{{amount_with_comma_separator}} lei',
    money_with_currency_format: '{{amount_with_comma_separator}} lei RON',
  },
  RUB: {
    money_format: '&#1088;&#1091;&#1073;{{amount_with_comma_separator}}',
    money_with_currency_format: '&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB',
  },
  RWF: {
    money_format: '{{amount_no_decimals}} RF',
    money_with_currency_format: '{{amount_no_decimals}} RWF',
  },
  WST: {
    money_format: 'WS$ {{amount}}',
    money_with_currency_format: 'WS$ {{amount}} WST',
  },
  SAR: {
    money_format: '{{amount}} SR',
    money_with_currency_format: '{{amount}} SAR',
  },
  STD: {
    money_format: 'Db {{amount}}',
    money_with_currency_format: 'Db {{amount}} STD',
  },
  RSD: {
    money_format: '{{amount}} RSD',
    money_with_currency_format: '{{amount}} RSD',
  },
  SCR: {
    money_format: 'Rs {{amount}}',
    money_with_currency_format: 'Rs {{amount}} SCR',
  },
  SGD: {
    money_format: '${{amount}}',
    money_with_currency_format: '${{amount}} SGD',
  },
  SYP: {
    money_format: 'S&pound;{{amount}}',
    money_with_currency_format: 'S&pound;{{amount}} SYP',
  },
  ZAR: {
    money_format: 'R {{amount}}',
    money_with_currency_format: 'R {{amount}} ZAR',
  },
  KRW: {
    money_format: '&#8361;{{amount_no_decimals}}',
    money_with_currency_format: '&#8361;{{amount_no_decimals}} KRW',
  },
  LKR: {
    money_format: 'Rs {{amount}}',
    money_with_currency_format: 'Rs {{amount}} LKR',
  },
  SEK: {
    money_format: '{{amount_no_decimals}} kr',
    money_with_currency_format: '{{amount_no_decimals}} kr SEK',
  },
  CHF: {
    money_format: 'SFr. {{amount}}',
    money_with_currency_format: 'SFr. {{amount}} CHF',
  },
  TWD: {
    money_format: '${{amount}}',
    money_with_currency_format: '${{amount}} TWD',
  },
  THB: {
    money_format: '{{amount}} &#xe3f;',
    money_with_currency_format: '{{amount}} &#xe3f; THB',
  },
  TZS: {
    money_format: '{{amount}} TZS',
    money_with_currency_format: '{{amount}} TZS',
  },
  TTD: {
    money_format: '${{amount}}',
    money_with_currency_format: '${{amount}} TTD',
  },
  TND: {
    money_format: '{{amount}}',
    money_with_currency_format: '{{amount}} DT',
  },
  TRY: {
    money_format: '{{amount}}TL',
    money_with_currency_format: '{{amount}}TL',
  },
  UGX: {
    money_format: 'Ush {{amount_no_decimals}}',
    money_with_currency_format: 'Ush {{amount_no_decimals}} UGX',
  },
  UAH: {
    money_format: '₴{{amount}}',
    money_with_currency_format: '₴{{amount}} UAH',
  },
  AED: {
    money_format: 'Dhs. {{amount}}',
    money_with_currency_format: 'Dhs. {{amount}} AED',
  },
  UYU: {
    money_format: '${{amount_with_comma_separator}}',
    money_with_currency_format: '${{amount_with_comma_separator}} UYU',
  },
  VUV: {
    money_format: '${{amount}}',
    money_with_currency_format: '${{amount}}VT',
  },
  VEF: {
    money_format: 'Bs. {{amount_with_comma_separator}}',
    money_with_currency_format: 'Bs. {{amount_with_comma_separator}} VEF',
  },
  VND: {
    money_format: '{{amount_no_decimals_with_comma_separator}}&#8363;',
    money_with_currency_format: '{{amount_no_decimals_with_comma_separator}} VND',
  },
  XBT: {
    money_format: '{{amount_no_decimals}} BTC',
    money_with_currency_format: '{{amount_no_decimals}} BTC',
  },
  XOF: {
    money_format: 'CFA{{amount}}',
    money_with_currency_format: 'CFA{{amount}} XOF',
  },
  ZMW: {
    money_format: 'K{{amount_no_decimals_with_comma_separator}}',
    money_with_currency_format: 'ZMW{{amount_no_decimals_with_comma_separator}}',
  },
};

Currency.formatMoney = function (cents, format) {
  if (typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents, format);
  }
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || '${{amount}}';
  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

Currency.currentCurrency = '';

Currency.format = 'money_with_currency_format';

Currency.convertAll = function (oldCurrency, newCurrency, selector, format) {
  jQuery(selector || 'span.money').each(function () {
    // If the amount has already been converted, we leave it alone.
    if (jQuery(this).attr('data-currency') === newCurrency) return;
    // If we are converting to a currency that we have saved, we will use the saved amount.
    if (jQuery(this).attr('data-currency-' + newCurrency)) {
      jQuery(this).html(jQuery(this).attr('data-currency-' + newCurrency));
    } else {
      // Converting to Y for the first time? Let's get to it!
      var cents = 0.0;
      var oldFormat = Currency.moneyFormats[oldCurrency][format || Currency.format] || '{{amount}}';
      var newFormat = Currency.moneyFormats[newCurrency][format || Currency.format] || '{{amount}}';
      if (oldFormat.indexOf('amount_no_decimals') !== -1) {
        cents = Currency.convert(
          parseInt(
            jQuery(this)
              .html()
              .replace(/[^0-9]/g, ''),
            10
          ) * 100,
          oldCurrency,
          newCurrency
        );
      } else if (oldCurrency === 'JOD' || oldCurrency == 'KWD' || oldCurrency == 'BHD') {
        cents = Currency.convert(
          parseInt(
            jQuery(this)
              .html()
              .replace(/[^0-9]/g, ''),
            10
          ) / 10,
          oldCurrency,
          newCurrency
        );
      } else {
        cents = Currency.convert(
          parseInt(
            jQuery(this)
              .html()
              .replace(/[^0-9]/g, ''),
            10
          ),
          oldCurrency,
          newCurrency
        );
      }
      var newFormattedAmount = Currency.formatMoney(cents, newFormat);
      jQuery(this).html(newFormattedAmount);
      jQuery(this).attr('data-currency-' + newCurrency, newFormattedAmount);
    }
    // We record the new currency locally.
    jQuery(this).attr('data-currency', newCurrency);
  });
  this.currentCurrency = newCurrency;
  this.cookie.write(newCurrency);
};
// Generated by CoffeeScript 1.9.3
(function () {
  var Instafeed;

  Instafeed = (function () {
    function Instafeed(params, context) {
      var option, value;
      this.options = {
        target: 'instafeed',
        get: 'popular',
        resolution: 'thumbnail',
        sortBy: 'none',
        links: true,
        mock: false,
        useHttp: false,
      };
      if (typeof params === 'object') {
        for (option in params) {
          value = params[option];
          this.options[option] = value;
        }
      }
      this.context = context != null ? context : this;
      this.unique = this._genKey();
    }

    Instafeed.prototype.hasNext = function () {
      return typeof this.context.nextUrl === 'string' && this.context.nextUrl.length > 0;
    };

    Instafeed.prototype.next = function () {
      if (!this.hasNext()) {
        return false;
      }
      return this.run(this.context.nextUrl);
    };

    Instafeed.prototype.run = function (url) {
      var header, instanceName, script;
      if (typeof this.options.clientId !== 'string') {
        if (typeof this.options.accessToken !== 'string') {
          throw new Error('Missing clientId or accessToken.');
        }
      }
      if (typeof this.options.accessToken !== 'string') {
        if (typeof this.options.clientId !== 'string') {
          throw new Error('Missing clientId or accessToken.');
        }
      }
      if (this.options.before != null && typeof this.options.before === 'function') {
        this.options.before.call(this);
      }
      if (typeof document !== 'undefined' && document !== null) {
        script = document.createElement('script');
        script.id = 'instafeed-fetcher';
        script.src = url || this._buildUrl();
        header = document.getElementsByTagName('head');
        header[0].appendChild(script);
        instanceName = 'instafeedCache' + this.unique;
        window[instanceName] = new Instafeed(this.options, this);
        window[instanceName].unique = this.unique;
      }
      return true;
    };

    Instafeed.prototype.parse = function (response) {
      var anchor,
        childNodeCount,
        childNodeIndex,
        childNodesArr,
        e,
        eMsg,
        fragment,
        header,
        htmlString,
        httpProtocol,
        i,
        image,
        imageObj,
        imageString,
        imageUrl,
        images,
        img,
        imgHeight,
        imgOrient,
        imgUrl,
        imgWidth,
        instanceName,
        j,
        k,
        len,
        len1,
        len2,
        node,
        parsedLimit,
        reverse,
        sortSettings,
        targetEl,
        tmpEl;
      if (typeof response !== 'object') {
        if (this.options.error != null && typeof this.options.error === 'function') {
          this.options.error.call(this, 'Invalid JSON data');
          return false;
        } else {
          throw new Error('Invalid JSON response');
        }
      }
      if (response.meta.code !== 200) {
        if (this.options.error != null && typeof this.options.error === 'function') {
          this.options.error.call(this, response.meta.error_message);
          return false;
        } else {
          throw new Error('Error from Instagram: ' + response.meta.error_message);
        }
      }
      if (response.data.length === 0) {
        if (this.options.error != null && typeof this.options.error === 'function') {
          this.options.error.call(this, 'No images were returned from Instagram');
          return false;
        } else {
          throw new Error('No images were returned from Instagram');
        }
      }
      if (this.options.success != null && typeof this.options.success === 'function') {
        this.options.success.call(this, response);
      }
      this.context.nextUrl = '';
      if (response.pagination != null) {
        this.context.nextUrl = response.pagination.next_url;
      }
      if (this.options.sortBy !== 'none') {
        if (this.options.sortBy === 'random') {
          sortSettings = ['', 'random'];
        } else {
          sortSettings = this.options.sortBy.split('-');
        }
        reverse = sortSettings[0] === 'least' ? true : false;
        switch (sortSettings[1]) {
          case 'random':
            response.data.sort(function () {
              return 0.5 - Math.random();
            });
            break;
          case 'recent':
            response.data = this._sortBy(response.data, 'created_time', reverse);
            break;
          case 'liked':
            response.data = this._sortBy(response.data, 'likes.count', reverse);
            break;
          case 'commented':
            response.data = this._sortBy(response.data, 'comments.count', reverse);
            break;
          default:
            throw new Error("Invalid option for sortBy: '" + this.options.sortBy + "'.");
        }
      }
      if (typeof document !== 'undefined' && document !== null && this.options.mock === false) {
        images = response.data;
        parsedLimit = parseInt(this.options.limit, 10);
        if (this.options.limit != null && images.length > parsedLimit) {
          images = images.slice(0, parsedLimit);
        }
        fragment = document.createDocumentFragment();
        if (this.options.filter != null && typeof this.options.filter === 'function') {
          images = this._filter(images, this.options.filter);
        }
        if (this.options.template != null && typeof this.options.template === 'string') {
          htmlString = '';
          imageString = '';
          imgUrl = '';
          tmpEl = document.createElement('div');
          for (i = 0, len = images.length; i < len; i++) {
            image = images[i];
            imageObj = image.images[this.options.resolution];
            if (typeof imageObj !== 'object') {
              eMsg = 'No image found for resolution: ' + this.options.resolution + '.';
              throw new Error(eMsg);
            }
            imgWidth = imageObj.width;
            imgHeight = imageObj.height;
            imgOrient = 'square';
            if (imgWidth > imgHeight) {
              imgOrient = 'landscape';
            }
            if (imgWidth < imgHeight) {
              imgOrient = 'portrait';
            }
            imageUrl = imageObj.url;
            httpProtocol = window.location.protocol.indexOf('http') >= 0;
            if (httpProtocol && !this.options.useHttp) {
              imageUrl = imageUrl.replace(/https?:\/\//, '//');
            }
            imageString = this._makeTemplate(this.options.template, {
              model: image,
              id: image.id,
              link: image.link,
              type: image.type,
              image: imageUrl,
              width: imgWidth,
              height: imgHeight,
              orientation: imgOrient,
              caption: this._getObjectProperty(image, 'caption.text'),
              likes: image.likes.count,
              comments: image.comments.count,
              location: this._getObjectProperty(image, 'location.name'),
            });
            htmlString += imageString;
          }
          tmpEl.innerHTML = htmlString;
          childNodesArr = [];
          childNodeIndex = 0;
          childNodeCount = tmpEl.childNodes.length;
          while (childNodeIndex < childNodeCount) {
            childNodesArr.push(tmpEl.childNodes[childNodeIndex]);
            childNodeIndex += 1;
          }
          for (j = 0, len1 = childNodesArr.length; j < len1; j++) {
            node = childNodesArr[j];
            fragment.appendChild(node);
          }
        } else {
          for (k = 0, len2 = images.length; k < len2; k++) {
            image = images[k];
            img = document.createElement('img');
            imageObj = image.images[this.options.resolution];
            if (typeof imageObj !== 'object') {
              eMsg = 'No image found for resolution: ' + this.options.resolution + '.';
              throw new Error(eMsg);
            }
            imageUrl = imageObj.url;
            httpProtocol = window.location.protocol.indexOf('http') >= 0;
            if (httpProtocol && !this.options.useHttp) {
              imageUrl = imageUrl.replace(/https?:\/\//, '//');
            }
            img.src = imageUrl;
            if (this.options.links === true) {
              anchor = document.createElement('a');
              anchor.href = image.link;
              anchor.appendChild(img);
              fragment.appendChild(anchor);
            } else {
              fragment.appendChild(img);
            }
          }
        }
        targetEl = this.options.target;
        if (typeof targetEl === 'string') {
          targetEl = document.getElementById(targetEl);
        }
        if (targetEl == null) {
          eMsg = 'No element with id="' + this.options.target + '" on page.';
          throw new Error(eMsg);
        }
        targetEl.appendChild(fragment);
        header = document.getElementsByTagName('head')[0];
        header.removeChild(document.getElementById('instafeed-fetcher'));
        instanceName = 'instafeedCache' + this.unique;
        window[instanceName] = void 0;
        try {
          delete window[instanceName];
        } catch (_error) {
          e = _error;
        }
      }
      if (this.options.after != null && typeof this.options.after === 'function') {
        this.options.after.call(this);
      }
      return true;
    };

    Instafeed.prototype._buildUrl = function () {
      var base, endpoint, final;
      base = 'https://api.instagram.com/v1';
      switch (this.options.get) {
        case 'popular':
          endpoint = 'media/popular';
          break;
        case 'tagged':
          if (!this.options.tagName) {
            throw new Error("No tag name specified. Use the 'tagName' option.");
          }
          endpoint = 'tags/' + this.options.tagName + '/media/recent';
          break;
        case 'location':
          if (!this.options.locationId) {
            throw new Error("No location specified. Use the 'locationId' option.");
          }
          endpoint = 'locations/' + this.options.locationId + '/media/recent';
          break;
        case 'user':
          if (!this.options.userId) {
            throw new Error("No user specified. Use the 'userId' option.");
          }
          endpoint = 'users/' + this.options.userId + '/media/recent';
          break;
        default:
          throw new Error("Invalid option for get: '" + this.options.get + "'.");
      }
      final = base + '/' + endpoint;
      if (this.options.accessToken != null) {
        final += '?access_token=' + this.options.accessToken;
      } else {
        final += '?client_id=' + this.options.clientId;
      }
      if (this.options.limit != null) {
        final += '&count=' + this.options.limit;
      }
      final += '&callback=instafeedCache' + this.unique + '.parse';
      return final;
    };

    Instafeed.prototype._genKey = function () {
      var S4;
      S4 = function () {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      };
      return '' + S4() + S4() + S4() + S4();
    };

    Instafeed.prototype._makeTemplate = function (template, data) {
      var output, pattern, ref, varName, varValue;
      pattern = /(?:\{{2})([\w\[\]\.]+)(?:\}{2})/;
      output = template;
      while (pattern.test(output)) {
        varName = output.match(pattern)[1];
        varValue = (ref = this._getObjectProperty(data, varName)) != null ? ref : '';
        output = output.replace(pattern, function () {
          return '' + varValue;
        });
      }
      return output;
    };

    Instafeed.prototype._getObjectProperty = function (object, property) {
      var piece, pieces;
      property = property.replace(/\[(\w+)\]/g, '.$1');
      pieces = property.split('.');
      while (pieces.length) {
        piece = pieces.shift();
        if (object != null && piece in object) {
          object = object[piece];
        } else {
          return null;
        }
      }
      return object;
    };

    Instafeed.prototype._sortBy = function (data, property, reverse) {
      var sorter;
      sorter = function (a, b) {
        var valueA, valueB;
        valueA = this._getObjectProperty(a, property);
        valueB = this._getObjectProperty(b, property);
        if (reverse) {
          if (valueA > valueB) {
            return 1;
          } else {
            return -1;
          }
        }
        if (valueA < valueB) {
          return 1;
        } else {
          return -1;
        }
      };
      data.sort(sorter.bind(this));
      return data;
    };

    Instafeed.prototype._filter = function (images, filter) {
      var filteredImages, fn, i, image, len;
      filteredImages = [];
      fn = function (image) {
        if (filter(image)) {
          return filteredImages.push(image);
        }
      };
      for (i = 0, len = images.length; i < len; i++) {
        image = images[i];
        fn(image);
      }
      return filteredImages;
    };

    return Instafeed;
  })();

  (function (root, factory) {
    if (typeof define === 'function' && define.amd) {
      return define([], factory);
    } else if (typeof module === 'object' && module.exports) {
      return (module.exports = factory());
    } else {
      return (root.Instafeed = factory());
    }
  })(this, function () {
    return Instafeed;
  });
}).call(this);

//Vertical and horizontal

(function ($) {
  $.fn.extend({
    scrollBar: function (options) {
      var settings = {
        barWidth: 8,
        position: 'x,y',
        wheelDis: 15,
      };

      options = $.extend(settings, options);

      var horizontalDiv =
        '<div class="zl-scrollBarBox" style="width:100%;left:0;height:' +
        settings.barWidth +
        'px;bottom:0;">' +
        '<div class="zl-scrollBar zl-horizontalBar" style="height:' +
        settings.barWidth +
        'px;border-radius:' +
        settings.barWidth / 2 +
        'px;"></div>' +
        '</div>';
      var verticalDiv =
        '<div class="zl-scrollBarBox" style="height:100%;top:0;width:' +
        settings.barWidth +
        'px;right:0;">' +
        '<div class="zl-scrollBar zl-verticalBar" style="width:' +
        settings.barWidth +
        'px;border-radius:' +
        settings.barWidth / 2 +
        'px;"></div>' +
        '</div>';

      var T = this;

      /**
       * 将每个div的padding值保存到自定义属性中
       */

      T.each(function () {
        $(this).attr('paddingR', $(this).css('padding-right')).attr('paddingB', $(this).css('padding-bottom'));
      });
      /**
       *
       *创建滚动条的函数
       */
      function creatScrollBar(obj) {
        var This = $(obj).get(0); //转化为JS对象，增加运行效率

        var paddingR = parseFloat($(obj).attr('paddingR'));
        var paddingB = parseFloat($(obj).attr('paddingB'));

        $(obj).css({
          'padding-right': paddingR + 'px',
          'padding-bottom': paddingB + 'px',
          overflow: 'hidden',
        });

        //获取内容的总高度和总宽度

        if (!$(obj).children().hasClass('zl-scrollContentDiv')) {
          $(obj).wrapInner('<div class="zl-scrollContentDiv"></div>');
        }

        if ($(obj).css('position') == 'static') {
          $(obj).css({position: 'relative'});
        }

        var scrollContentDiv = $(obj).find('.zl-scrollContentDiv');

        var scrollH = scrollContentDiv[0].scrollHeight;
        var scrollW = scrollContentDiv[0].scrollWidth;

        var innerH = scrollContentDiv.height();
        var innerW = scrollContentDiv.width();
        var outerH = $(obj).innerHeight();
        var outerW = $(obj).innerWidth();

        function addVerticalBar(a) {
          This.style.paddingRight = paddingR + settings.barWidth + 'px';

          innerH = $(a).height();

          var barHeight = outerH * (innerH / scrollH);

          $(a).find('.zl-scrollBarBox').remove().end().append(verticalDiv).find('.zl-verticalBar').height(barHeight);
        }
        function addHorizontalBar(a) {
          This.style.paddingBottom = paddingB + settings.barWidth + 'px';
          innerW = $(a).width();

          var barWidth = outerW * (innerW / scrollW);

          $(a).find('.zl-scrollBarBox').remove().end().append(horizontalDiv).find('.zl-horizontalBar').width(barWidth);
        }

        switch (settings.position) {
          case 'x,y':
            if (scrollH > innerH && scrollW > innerW) {
              This.style.paddingRight = paddingR + settings.barWidth + 'px';
              innerH = $(obj).height();
              outerH = $(obj).innerHeight();

              var barHeight = (outerH - settings.barWidth) * ((innerH - settings.barWidth) / scrollH);
              if (!$(obj).find('.zl-verticalBar').length) {
                $(obj).append(verticalDiv);
              }

              $(obj)
                .find('.zl-verticalBar')
                .height(barHeight)
                .parent()
                .height(outerH - settings.barWidth);

              This.style.paddingBottom = paddingB + settings.barWidth + 'px';
              innerW = $(obj).width();

              var barWidth = (outerW - settings.barWidth) * ((innerW - settings.barWidth) / scrollW);

              if (!$(obj).find('.zl-horizontalBar').length) {
                $(obj).append(horizontalDiv);
              }
              $(obj)
                .find('.zl-horizontalBar')
                .width(barWidth)
                .parent()
                .width(outerW)
                .css({
                  'padding-right': settings.barWidth + 'px',
                  'box-sizing': 'border-box',
                });
            } else if (scrollH > innerH) {
              addVerticalBar(obj);
            } else if (scrollW > innerW) {
              addHorizontalBar(obj);
            } else {
              $(obj).find('.zl-scrollBarBox').remove();
            }
            break;

          case 'x':
            if (scrollW > innerW) {
              addHorizontalBar(obj);
            } else {
              $(obj).find('.zl-scrollBarBox').remove();
            }
            break;

          case 'y':
            if (scrollH > innerH) {
              addVerticalBar(obj);
            } else {
              $(obj).find('.zl-scrollBarBox').remove();
            }

            break;
        }
      }

      /**
       * 循环给每一个Div添加
       */
      function recycleThis() {
        T.each(function () {
          creatScrollBar(this);
        });
      }

      recycleThis(); //执行循环

      /**
       *创建监听div内容变化的定时器
       */

      function creatTimer(obj, oldWidth, oldHeight, oldInnerWidth, oldInnerHeight, timer) {
        timer = setInterval(function () {
          var newWidth = null;
          var newHeight = null;
          var newInnerWidth = null;
          var newInnerHeight = null;
          var topDiv = null;
          var leftDiv = null;
          var topBar = null;
          var leftBar = null;
          var scrollContentDiv = $(obj).find('.zl-scrollContentDiv');

          if (scrollContentDiv.length) {
            newWidth = scrollContentDiv[0].scrollWidth;
            newHeight = scrollContentDiv[0].scrollHeight;

            newInnerWidth = scrollContentDiv.width();
            newInnerHeight = scrollContentDiv.height();
          } else {
            newWidth = $(obj)[0].scrollWidth - parseFloat($(obj).css('padding-left'));
            newHeight = $(obj)[0].scrollHeight - parseFloat($(obj).css('padding-top'));
            newInnerWidth = $(obj).width();
            newInnerHeight = $(obj).height();
          }

          if (
            newWidth != oldWidth ||
            newHeight != oldHeight ||
            newInnerWidth != oldInnerWidth ||
            newInnerHeight != oldInnerHeight
          ) {
            //记录更新滚动条长短前的位置
            if (scrollContentDiv.length) {
              topDiv = parseFloat(scrollContentDiv.css('top'));
              leftDiv = parseFloat(scrollContentDiv.css('left'));
            }
            if ($(obj).find('.zl-verticalBar').length) {
              topBar = parseFloat($(obj).find('.zl-verticalBar').css('top'));
            }
            if ($(obj).find('.zl-horizontalBar').length) {
              leftBar = parseFloat($(obj).find('.zl-horizontalBar').css('left'));
            }
            //更新滚动条长短或有无
            creatScrollBar(obj);

            if ($(obj).find('.zl-scrollBarBox').length) {
              if (topDiv) {
                var maxTopBox = scrollContentDiv[0].scrollHeight - $(obj).height();
                var maxLeftBox = scrollContentDiv[0].scrollWidth - $(obj).width();
                if (-leftDiv > maxLeftBox) {
                  leftDiv = -maxLeftBox;
                }
                if (-topDiv > maxTopBox) {
                  topDiv = -maxTopBox;
                }
                scrollContentDiv.css({
                  left: leftDiv + 'px',
                  top: topDiv + 'px',
                });
              }
              //将原来的位置赋值给现在的滚动条
              if (topBar && $(obj).find('.zl-verticalBar').length) {
                var verticalBar = $(obj).find('.zl-verticalBar');
                var maxTop = verticalBar.parent().height() - verticalBar.height();

                if (topBar > maxTop) {
                  topBar = maxTop;
                }
                verticalBar.css('top', topBar + 'px');
              }
              if (leftBar && $(obj).find('.zl-horizontalBar').length) {
                var horizontalBar = $(obj).find('.zl-verticalBar');
                var maxLeft = horizontalBar.parent().width() - horizontalBar.width();

                if (leftBar > maxLeft) {
                  leftBar = maxLeft;
                }

                $(obj)
                  .find('.zl-horizontalBar')
                  .css('left', leftBar + 'px');
              }
            }

            oldWidth = newWidth;
            oldHeight = newHeight;

            oldInnerHeight = newInnerHeight;
            oldInnerWidth = newInnerWidth;
          }
        }, 100);
      }

      /**
       * 通过循环给每一个div添加上监听内容变化的定时器
       */
      function addTimer() {
        $.each(T, function (k, v) {
          var obj = v;
          var timer = 'timer' + k;
          var oldWidth = null;
          var oldHeight = null;
          var oldInnerWidth = null;
          var oldInnerHeight = null;

          if ($(v).find('.zl-scrollContentDiv').length) {
            oldWidth = $(v).find('.zl-scrollContentDiv')[0].scrollWidth;
            oldHeight = $(v).find('.zl-scrollContentDiv')[0].scrollHeight;
            oldInnerWidth = $(v).find('.zl-scrollContentDiv').width();
            oldInnerHeight = $(v).find('.zl-scrollContentDiv').height();
          } else {
            oldWidth = $(obj)[0].scrollWidth - parseFloat($(obj).css('padding-left'));
            oldHeight = $(obj)[0].scrollHeight - parseFloat($(obj).css('padding-top'));

            oldInnerWidth = $(obj).width();
            oldInnerHeight = $(obj).height();
          }
          creatTimer(obj, oldWidth, oldHeight, oldInnerWidth, oldInnerHeight, timer);
        });
      }
      addTimer();
      function clearTimer() {
        $.each(T, function (index, item) {
          var timer = 'timer' + index;
          clearInterval(timer);
        });
      }
      /**
       * 滚动条拖拽效果
       */
      this.on('mousedown', '.zl-scrollBar', function (ev) {
        clearTimer(); //清除定时器

        var direction = null;

        if ($(this).hasClass('zl-verticalBar')) {
          direction = '0';
        } else if ($(this).hasClass('zl-horizontalBar')) {
          direction = '1';
        }

        var This = $(this).get(0);

        var height = $(this).parent().height() - $(this).height();
        var width = $(this).parent().width() - $(this).width();

        var contentDiv = $(this).parent().parent().find('.zl-scrollContentDiv').get(0);

        var scrollH = contentDiv.scrollHeight;
        var innerH = $(this).parent().parent().height();

        var scrollW = contentDiv.scrollWidth;
        var innerW = $(this).parent().parent().width();

        var ev = ev || event;

        var disY = ev.clientY - This.offsetTop;
        var disX = ev.clientX - This.offsetLeft;

        var topCount = null;
        var leftCount = null;

        switch (direction) {
          case '0':
            document.onmousemove = function (ev) {
              var ev = ev || event;

              if (ev.clientY - disY <= 0) {
                topCount = 0;
              } else if (ev.clientY - disY >= height) {
                topCount = height;
              } else {
                topCount = ev.clientY - disY;
              }

              This.style.top = topCount + 'px';

              contentDiv.style.top = -((topCount * (scrollH - innerH)) / height) + 'px';
            };

            break;

          case '1':
            document.onmousemove = function (ev) {
              var ev = ev || event;

              if (ev.clientX - disX <= 0) {
                leftCount = 0;
              } else if (ev.clientX - disX >= width) {
                leftCount = width;
              } else {
                leftCount = ev.clientX - disX;
              }

              This.style.left = leftCount + 'px';

              contentDiv.style.left = -((leftCount * (scrollW - innerW)) / width) + 'px';
            };

            break;
        }

        document.onmouseup = function () {
          document.onmousemove = null;
          document.onmouseup = null;

          addTimer(); //添加定时器
        };

        return false;
      });

      /**
       *鼠标滚轮效果
       */

      function fn(ev, a) {
        if (a.find('.zl-verticalBar').length) {
          var b = true;
          var height = a.find('.zl-scrollBarBox').height() - a.find('.zl-scrollBar').height();
          var contentDiv = a.find('.zl-scrollContentDiv').get(0);
          var scrollH = contentDiv.scrollHeight;
          var innerH = a.height();

          if (ev.wheelDelta) {
            b = ev.wheelDelta > 0 ? true : false;
          } else {
            b = ev.detail < 0 ? true : false;
          }

          var topDis = parseFloat(a.find('.zl-scrollBar').css('top'));

          if (b) {
            topDis -= settings.wheelDis;

            if (topDis < 0) {
              topDis = 0;
            }
          } else {
            topDis += settings.wheelDis;

            if (topDis > height) {
              topDis = height;
            }
          }

          a.find('.zl-scrollBar').get(0).style.top = topDis + 'px';
          a.find('.zl-scrollContentDiv').get(0).style.top = -((topDis * (scrollH - innerH)) / height) + 'px';
        }
      }

      T.each(function () {
        var oDiv = $(this).get(0);

        if (oDiv.addEventListener) {
          oDiv.addEventListener(
            'DOMMouseScroll',
            function (ev) {
              var ev = ev || event;
              var $This = $(this);

              fn(ev, $This);

              ev.preventDefault();
            },
            false
          );
        }

        oDiv.onmousewheel = function (ev) {
          var ev = ev || event;
          var $This = $(this);

          fn(ev, $This);

          return false;
        };
      });

      return this;
    },
  });
})(jQuery);

/*!
 * smoothState.js is jQuery plugin that progressively enhances
 * page loads to behave more like a single-page application.
 *
 * @author  Miguel Ángel Pérez   reachme@miguel-perez.com
 * @see     http://smoothstate.com
 *
 */
!(function (t) {
  'use strict';
  'object' == typeof module && 'object' == typeof module.exports
    ? t(require('jquery'), window, document)
    : t(jQuery, window, document);
})(function (t, e, n, o) {
  'use strict';
  if (!e.history.pushState)
    return (
      (t.fn.smoothState = function () {
        return this;
      }),
      void (t.fn.smoothState.options = {})
    );
  if (!t.fn.smoothState) {
    var r = t('html, body'),
      a = e.console,
      i = {
        debug: !1,
        anchors: 'a',
        hrefRegex: '',
        forms: 'form',
        allowFormCaching: !1,
        repeatDelay: 500,
        blacklist: '.no-smoothState',
        prefetch: !1,
        prefetchOn: 'mouseover touchstart',
        prefetchBlacklist: '.no-prefetch',
        locationHeader: 'X-SmoothState-Location',
        cacheLength: 0,
        loadingClass: 'is-loading',
        scroll: !0,
        alterRequest: function (t) {
          return t;
        },
        alterChangeState: function (t, e, n) {
          return t;
        },
        onBefore: function (t, e) {},
        onStart: {duration: 0, render: function (t) {}},
        onProgress: {duration: 0, render: function (t) {}},
        onReady: {
          duration: 0,
          render: function (t, e) {
            t.html(e);
          },
        },
        onAfter: function (t, e) {},
      },
      s = {
        isExternal: function (t) {
          var n = t.match(/^([^:\/?#]+:)?(?:\/\/([^\/?#]*))?([^?#]+)?(\?[^#]*)?(#.*)?/);
          return 'string' == typeof n[1] && n[1].length > 0 && n[1].toLowerCase() !== e.location.protocol
            ? !0
            : 'string' == typeof n[2] &&
                n[2].length > 0 &&
                n[2].replace(new RegExp(':(' + {'http:': 80, 'https:': 443}[e.location.protocol] + ')?$'), '') !==
                  e.location.host;
        },
        stripHash: function (t) {
          return t.replace(/#.*/, '');
        },
        isHash: function (t, n) {
          n = n || e.location.href;
          var o = t.indexOf('#') > -1,
            r = s.stripHash(t) === s.stripHash(n);
          return o && r;
        },
        translate: function (e) {
          var n = {dataType: 'html', type: 'GET'};
          return (e = 'string' == typeof e ? t.extend({}, n, {url: e}) : t.extend({}, n, e));
        },
        shouldLoadAnchor: function (t, e, n) {
          var r = t.prop('href');
          return !(
            s.isExternal(r) ||
            s.isHash(r) ||
            t.is(e) ||
            t.prop('target') ||
            (typeof n !== o && '' !== n && -1 === t.prop('href').search(n))
          );
        },
        clearIfOverCapacity: function (t, e) {
          return (
            Object.keys ||
              (Object.keys = function (t) {
                var e,
                  n = [];
                for (e in t) Object.prototype.hasOwnProperty.call(t, e) && n.push(e);
                return n;
              }),
            Object.keys(t).length > e && (t = {}),
            t
          );
        },
        storePageIn: function (e, n, o, r, a, i) {
          var s = t('<html></html>').append(t(o));
          return (
            'undefined' == typeof a && (a = {}),
            'undefined' == typeof i && (i = n),
            (e[n] = {
              status: 'loaded',
              title: s.find('title').first().text(),
              html: s.find('#' + r),
              doc: o,
              state: a,
              destUrl: i,
            }),
            e
          );
        },
        triggerAllAnimationEndEvent: function (e, n) {
          n = ' ' + n || '';
          var o = 0,
            r = 'animationstart webkitAnimationStart oanimationstart MSAnimationStart',
            a = 'animationend webkitAnimationEnd oanimationend MSAnimationEnd',
            i = 'allanimationend',
            l = function (n) {
              t(n.delegateTarget).is(e) && (n.stopPropagation(), o++);
            },
            u = function (n) {
              t(n.delegateTarget).is(e) && (n.stopPropagation(), o--, 0 === o && e.trigger(i));
            };
          e.on(r, l),
            e.on(a, u),
            e.on('allanimationend' + n, function () {
              (o = 0), s.redraw(e);
            });
        },
        redraw: function (t) {
          t.height();
        },
      },
      l = function (n) {
        if (null !== n.state) {
          var o = e.location.href,
            r = t('#' + n.state.id),
            a = r.data('smoothState'),
            i = a.href !== o && !s.isHash(o, a.href),
            l = n.state !== a.cache[a.href].state;
          (i || l) && (l && a.clear(a.href), a.load(o, !1));
        }
      },
      u = function (i, l) {
        var u = t(i),
          c = u.prop('id'),
          f = null,
          d = !1,
          h = {},
          p = {},
          g = e.location.href,
          m = function (t) {
            (t = t || !1), t && h.hasOwnProperty(t) ? delete h[t] : (h = {}), (u.data('smoothState').cache = h);
          },
          y = function (e, n) {
            n = n || t.noop;
            var o = s.translate(e);
            if (
              ((h = s.clearIfOverCapacity(h, l.cacheLength)), !h.hasOwnProperty(o.url) || 'undefined' != typeof o.data)
            ) {
              h[o.url] = {status: 'fetching'};
              var r = t.ajax(o);
              r.done(function (t) {
                s.storePageIn(h, o.url, t, c), (u.data('smoothState').cache = h);
              }),
                r.fail(function () {
                  h[o.url].status = 'error';
                }),
                l.locationHeader &&
                  r.always(function (t, e, n) {
                    var r = t.statusCode ? t : n,
                      a = r.getResponseHeader(l.locationHeader);
                    a && (h[o.url].destUrl = a);
                  }),
                n && r.always(n);
            }
          },
          v = function () {
            if (f) {
              var e = t(f, u);
              if (e.length) {
                var n = e.offset().top;
                r.scrollTop(n);
              }
              f = null;
            }
          },
          S = function (o) {
            var i = '#' + c,
              s = h[o] ? t(h[o].html.html()) : null;
            s.length
              ? ((n.title = h[o].title),
                (u.data('smoothState').href = o),
                l.loadingClass && r.removeClass(l.loadingClass),
                l.onReady.render(u, s),
                u.one('ss.onReadyEnd', function () {
                  (d = !1), l.onAfter(u, s), l.scroll && v(), O(u);
                }),
                e.setTimeout(function () {
                  u.trigger('ss.onReadyEnd');
                }, l.onReady.duration))
              : !s && l.debug && a
                ? a.warn('No element with an id of ' + i + ' in response from ' + o + ' in ' + h)
                : (e.location = o);
          },
          w = function (t, n, o) {
            var i = s.translate(t);
            'undefined' == typeof n && (n = !0), 'undefined' == typeof o && (o = !0);
            var f = !1,
              d = !1,
              g = {
                loaded: function () {
                  var t = f ? 'ss.onProgressEnd' : 'ss.onStartEnd';
                  if (
                    (d && f
                      ? d && S(i.url)
                      : u.one(t, function () {
                          S(i.url), o || m(i.url);
                        }),
                    n)
                  ) {
                    var r = h[i.url].destUrl;
                    (p = l.alterChangeState({id: c}, h[i.url].title, r)),
                      (h[i.url].state = p),
                      e.history.pushState(p, h[i.url].title, r);
                  }
                  d && !o && m(i.url);
                },
                fetching: function () {
                  f ||
                    ((f = !0),
                    u.one('ss.onStartEnd', function () {
                      l.loadingClass && r.addClass(l.loadingClass),
                        l.onProgress.render(u),
                        e.setTimeout(function () {
                          u.trigger('ss.onProgressEnd'), (d = !0);
                        }, l.onProgress.duration);
                    })),
                    e.setTimeout(function () {
                      h.hasOwnProperty(i.url) && g[h[i.url].status]();
                    }, 10);
                },
                error: function () {
                  l.debug && a ? a.log('There was an error loading: ' + i.url) : (e.location = i.url);
                },
              };
            h.hasOwnProperty(i.url) || y(i),
              l.onStart.render(u),
              e.setTimeout(function () {
                l.scroll && r.scrollTop(0), u.trigger('ss.onStartEnd');
              }, l.onStart.duration),
              g[h[i.url].status]();
          },
          E = function (e) {
            var n,
              o = t(e.currentTarget);
            s.shouldLoadAnchor(o, l.blacklist, l.hrefRegex) &&
              !d &&
              (e.stopPropagation(), (n = s.translate(o.prop('href'))), (n = l.alterRequest(n)), y(n));
          },
          b = function (e) {
            var n = t(e.currentTarget);
            if (
              !e.metaKey &&
              !e.ctrlKey &&
              s.shouldLoadAnchor(n, l.blacklist, l.hrefRegex) &&
              (e.stopPropagation(), e.preventDefault(), !T())
            ) {
              A();
              var o = s.translate(n.prop('href'));
              (d = !0), (f = n.prop('hash')), (o = l.alterRequest(o)), l.onBefore(n, u), w(o);
            }
          },
          C = function (e) {
            var n = t(e.currentTarget);
            if (!n.is(l.blacklist) && (e.preventDefault(), e.stopPropagation(), !T())) {
              A();
              var r = {url: n.prop('action'), data: n.serialize(), type: n.prop('method')};
              (d = !0),
                (r = l.alterRequest(r)),
                'get' === r.type.toLowerCase() && (r.url = r.url + '?' + r.data),
                l.onBefore(n, u),
                w(r, o, l.allowFormCaching);
            }
          },
          P = 0,
          T = function () {
            var t = null === l.repeatDelay,
              e = parseInt(Date.now()) > P;
            return !(t || e);
          },
          A = function () {
            P = parseInt(Date.now()) + parseInt(l.repeatDelay);
          },
          O = function (t) {
            l.anchors && l.prefetch && t.find(l.anchors).not(l.prefetchBlacklist).on(l.prefetchOn, null, E);
          },
          R = function (t) {
            l.anchors && (t.on('click', l.anchors, b), O(t)), l.forms && t.on('submit', l.forms, C);
          },
          x = function () {
            var t = u.prop('class');
            u.removeClass(t), s.redraw(u), u.addClass(t);
          };
        return (
          (l = t.extend({}, t.fn.smoothState.options, l)),
          null === e.history.state
            ? ((p = l.alterChangeState({id: c}, n.title, g)), e.history.replaceState(p, n.title, g))
            : (p = {}),
          s.storePageIn(h, g, n.documentElement.outerHTML, c, p),
          s.triggerAllAnimationEndEvent(u, 'ss.onStartEnd ss.onProgressEnd ss.onEndEnd'),
          R(u),
          {href: g, cache: h, clear: m, load: w, fetch: y, restartCSSAnimations: x}
        );
      },
      c = function (e) {
        return this.each(function () {
          var n = this.tagName.toLowerCase();
          this.id && 'body' !== n && 'html' !== n && !t.data(this, 'smoothState')
            ? t.data(this, 'smoothState', new u(this, e))
            : !this.id && a
              ? a.warn('Every smoothState container needs an id but the following one does not have one:', this)
              : ('body' !== n && 'html' !== n) ||
                !a ||
                a.warn('The smoothstate container cannot be the ' + this.tagName + ' tag');
        });
      };
    (e.onpopstate = l), (t.smoothStateUtility = s), (t.fn.smoothState = c), (t.fn.smoothState.options = i);
  }
});

// Declare this for the stock counter check on lipstick
var variantQuantities = [];

$(document).ready(function () {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace(
      'supports-no-cookies',
      'supports-cookies'
    );
  }

  // When add to cart button is clicked, we can store the button object in a shared name space
  // So the cart js functions inside additional-cart.js can choose just one correct button
  $('[data-add-to-cart]').on('click', function () {
    window.selectorButton = {button: this};
  });
});

// Shipping notice
var closeButton = document.querySelector('.pop-up-close');
var shippingNotice = document.querySelector('.shipping-notice');

function removeShippingNotice() {
  if (shippingNotice && shippingNotice.parentNode) {
    shippingNotice.parentNode.removeChild(shippingNotice);
  }
}

if (closeButton) {
  closeButton.addEventListener('click', removeShippingNotice);
}

setTimeout(removeShippingNotice, 10000);
window.addEventListener('DOMContentLoaded', function () {
  var shippingNotice = document.getElementById('shippingNotice');
  var hasShownNotice = sessionStorage.getItem('hasShownNotice');

  if (!hasShownNotice && shippingNotice) {
    shippingNotice.style.display = 'block';
    sessionStorage.setItem('hasShownNotice', true);
  }

  if (closeButton) closeButton.addEventListener('click', removeShippingNotice);

  setTimeout(removeShippingNotice, 10000);
  window.addEventListener('DOMContentLoaded', function () {
    var shippingNotice = document.getElementById('shippingNotice');
    if (!shippingNotice) return;

    var hasShownNotice = sessionStorage.getItem('hasShownNotice');
    if (!hasShownNotice) {
      shippingNotice.style.display = 'block';
      sessionStorage.setItem('hasShownNotice', true);
    }
  });
});

function setHeaderHeightVar() {
  window.requestAnimationFrame(() => {
    const headerHeight = document.querySelector('.header-inner').offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  });
}

window.addEventListener('resize', setHeaderHeightVar);


